


// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Avatar,
//   Button,
//   useMediaQuery,
//   CircularProgress,
//   Modal,
//   IconButton,
//   Snackbar,
//   Alert,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   InputAdornment
// } from '@mui/material';
// import { useSelector } from 'react-redux';
// import { useNavigate, useParams, useLocation } from 'react-router-dom';
// import CloseIcon from '@mui/icons-material/Close';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import ShareIcon from '@mui/icons-material/Share';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// // Images
// import avatarIcon from '../../../assets/prof.png';
// import locationIcon from '../../../assets/loc.png';
// import calendarIcon from '../../../assets/calendar.png';
// import viewsIcon from '../../../assets/eye.png';
// import saveIcon from '../../../assets/logsave.png';
// import shareIcon from '../../../assets/logshare.png';
// import youtubeIcon from '../../../assets/logicon.png';
// import contactim from '../../../assets/conta.png';
// import similarImg from '../../../assets/sideimg.jpg';

// // Import Material UI icons for amenities
// import BedIcon from '@mui/icons-material/Bed';
// import BathtubIcon from '@mui/icons-material/Bathtub';
// import SquareFootIcon from '@mui/icons-material/SquareFoot';
// import ApartmentIcon from '@mui/icons-material/Apartment';
// import ElevatorIcon from '@mui/icons-material/Elevator';
// import LocalParkingIcon from '@mui/icons-material/LocalParking';
// import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
// import PoolIcon from '@mui/icons-material/Pool';
// import PetsIcon from '@mui/icons-material/Pets';
// import AcUnitIcon from '@mui/icons-material/AcUnit';
// import TvIcon from '@mui/icons-material/Tv';
// import ChairIcon from '@mui/icons-material/Chair';
// import KitchenIcon from '@mui/icons-material/Kitchen';
// import WeekendIcon from '@mui/icons-material/Weekend';
// import WifiIcon from '@mui/icons-material/Wifi';
// import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
// import MicrowaveIcon from '@mui/icons-material/Microwave';
// import PowerIcon from '@mui/icons-material/Power';
// import SecurityIcon from '@mui/icons-material/Security';
// import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
// import ChildCareIcon from '@mui/icons-material/ChildCare';
// import HouseIcon from '@mui/icons-material/House';
// import ParkIcon from '@mui/icons-material/Park';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import AspectRatioIcon from '@mui/icons-material/AspectRatio';
// import TerrainIcon from '@mui/icons-material/Terrain';
// import StraightenIcon from '@mui/icons-material/Straighten';

// // Import the CreateInquiry component
// import CreateInquiry from './CreateInquiry';

// const TalkView = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { propertyId } = useParams();
//   const isMobile = useMediaQuery('(max-width:768px)');
//   const user = useSelector((state) => state.user.user);
//   const isLoggedIn = !!user?.token;
//   const propertyIds = useSelector((state) => state.user.properties);

//   const isSharedView = location.search.includes('shared=true');

//   const [property, setProperty] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [propertyMedia, setPropertyMedia] = useState([]);
//   const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [sellerDetails, setSellerDetails] = useState(null);
//   const [similarProperties, setSimilarProperties] = useState([]);
//   const [loadingSimilar, setLoadingSimilar] = useState(false);
//   const [inquiryDialog, setInquiryDialog] = useState({
//     open: false,
//     propertyId: propertyId ? parseInt(propertyId) : null,
//     propertyTitle: ''
//   });
//   const [isFavorite, setIsFavorite] = useState(false);
//   const [toast, setToast] = useState({
//     open: false,
//     message: '',
//     severity: 'success'
//   });
//   const [shareDialog, setShareDialog] = useState(false);
//   const [shareUrl, setShareUrl] = useState('');

//   const hasValue = (value) => {
//     if (value === null || value === undefined) return false;
//     if (typeof value === 'string') {
//       const trimmed = value.trim();
//       return trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined' && trimmed !== 'N/A';
//     }
//     if (typeof value === 'number') return !isNaN(value) && value !== 0;
//     return true;
//   };

//   const getFurnishingTypeName = (furnishType) => {
//     if (!furnishType) return '';
//     const furnishingMap = {
//       'un': 'Unfurnished',
//       'unfurnished': 'Unfurnished',
//       'un-furnished': 'Unfurnished',
//       'semi': 'Semi-Furnished',
//       'semi-furnished': 'Semi-Furnished',
//       'full': 'Fully Furnished',
//       'fully': 'Fully Furnished',
//       'fully-furnished': 'Fully Furnished'
//     };
//     const lowerType = furnishType.toLowerCase().trim();
//     return furnishingMap[lowerType] || furnishType.replace(/-/g, ' ');
//   };

//   const getAmenityIcon = (amenityType) => {
//     const amenityIconMap = {
//       'Lift': ElevatorIcon,
//       'Parking': LocalParkingIcon,
//       'Gym': FitnessCenterIcon,
//       'Swimming Pool': PoolIcon,
//       'Pet Allowed': PetsIcon,
//       'AC': AcUnitIcon,
//       'TV': TvIcon,
//       'Sofa': ChairIcon,
//       'Fridge': KitchenIcon,
//       'Furnished': WeekendIcon,
//       'Internet': WifiIcon,
//       'Washing Machine': LocalLaundryServiceIcon,
//       'Microwave': MicrowaveIcon,
//       'Power Backup': PowerIcon,
//       'Security': SecurityIcon,
//       'Sports': SportsBaseballIcon,
//       'Children Area': ChildCareIcon,
//       'Club House': HouseIcon,
//       'Garden': ParkIcon,
//       'Modular Kitchen': KitchenIcon,
//       'BHK': BedIcon,
//       'Floor': ApartmentIcon,
//       'Size': SquareFootIcon,
//       'Bathroom': BathtubIcon,
//       'Facilities Distance': LocationOnIcon,
//       'Carpet Area': AspectRatioIcon,
//       'Built-up Area': AspectRatioIcon,
//       'UDS': TerrainIcon,
//       'Property Size': SquareFootIcon,
//       'Length': StraightenIcon,
//       'Width': StraightenIcon,
//       'Zone Type': TerrainIcon
//     };
//     const IconComponent = amenityIconMap[amenityType] || SquareFootIcon;
//     return <IconComponent sx={{ color: '#666', fontSize: 24 }} />;
//   };

//   const processMedia = (propertyData) => {
//     const media = [];
//     if (propertyData.images && Array.isArray(propertyData.images)) {
//       propertyData.images.forEach((img, index) => {
//         if (img.image) {
//           const dataUrl = `data:image/jpeg;base64,${img.image}`;
//           media.push({
//             type: 'image',
//             src: dataUrl,
//             name: `property-image-${index + 1}`,
//             thumbnail: dataUrl
//           });
//         }
//         if (img.video_name) {
//           media.push({
//             type: 'video',
//             src: `https://propertydealstalk.com/uploads/videos/${img.video_name}`,
//             name: img.video_name,
//             thumbnail: youtubeIcon
//           });
//         }
//       });
//     }
//     return media;
//   };

//   const fetchAdminDetails = async (adminId) => {
//     try {
//       console.log('🔍 Fetching admin details for admin_id:', adminId);
//       const response = await fetch(`https://propertydealstalk.com/api/admin/getAdmin?admin_id=${adminId}`);
      
//       if (!response.ok) {
//         throw new Error('Failed to fetch admin details');
//       }

//       const data = await response.json();
//       console.log('📦 Admin API Response:', data);

//       if (data.statusCode === 200 && data.result) {
//         const adminData = Array.isArray(data.result) ? data.result[0] : data.result;
//         setSellerDetails({
//           full_name: adminData.full_name || 'Admin',
//           contact_number: adminData.contact_number || adminData.phone || 'N/A',
//           email_id: adminData.email_id || adminData.email || 'N/A',
//           profile_image: adminData.profile_image || avatarIcon,
//           role: 'admin'
//         });
//         console.log('✅ Admin details set successfully:', adminData);
//       }
//     } catch (err) {
//       console.error('❌ Error fetching admin details:', err);
//       setSellerDetails({
//         full_name: 'Property Owner',
//         contact_number: '+91 XXXXXXXXXX',
//         email_id: 'contact@propertydealstalk.com',
//         profile_image: avatarIcon,
//         role: 'unknown'
//       });
//     }
//   };

//   const fetchSellerDetails = async (sellerId) => {
//     try {
//       console.log('🔍 Fetching seller details for seller_id:', sellerId);
//       const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${sellerId}`);
      
//       if (!response.ok) {
//         throw new Error('Failed to fetch seller details');
//       }

//       const data = await response.json();
//       console.log('📦 Seller API Response:', data);

//       if (data.status === "SUCCESS" && data.result) {
//         setSellerDetails({
//           full_name: data.result.full_name || 'Seller',
//           contact_number: data.result.contact_number || 'N/A',
//           email_id: data.result.email_id || 'N/A',
//           profile_image: data.result.profile_image || avatarIcon,
//           role: 'seller'
//         });
//         console.log('✅ Seller details updated successfully');
//       }
//     } catch (err) {
//       console.error('❌ Error fetching seller details:', err);
//     }
//   };

//   const checkFavoriteStatus = async (propId) => {
//     if (!isLoggedIn || !user?.id || isSharedView) {
//       setIsFavorite(false);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `https://propertydealstalk.com/api/buyer/getFavoritesByBuyerId?buyer_id=${user.id}`
//       );
//       const data = await response.json();

//       if (data.statusCode === 200 && data.result) {
//         const favorites = Array.isArray(data.result) ? data.result : [];
//         const isInFavorites = favorites.some(
//           fav => fav.property?.id === parseInt(propId) || fav.property_id === parseInt(propId)
//         );
//         setIsFavorite(isInFavorites);
//         console.log('✅ Favorite status checked:', isInFavorites);
//       } else {
//         setIsFavorite(false);
//       }
//     } catch (err) {
//       console.error('Error checking favorite status:', err);
//       setIsFavorite(false);
//     }
//   };

//   const toggleFavorite = async () => {
//     if (!isLoggedIn) {
//       navigate('/login');
//       return;
//     }

//     try {
//       if (isFavorite) {
//         const response = await fetch('https://www.propertydealstalk.com/api/buyer/removeFavorite', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             buyer_id: user?.id,
//             property_id: parseInt(property?.id || propertyId)
//           })
//         });

//         const data = await response.json();

//         if (data.statusCode === 200) {
//           setIsFavorite(false);
//           setToast({
//             open: true,
//             message: 'Property removed from favorites successfully',
//             severity: 'success'
//           });
//           console.log('✅ Property removed from favorites');
//         } else {
//           throw new Error(data.message || 'Failed to remove property from favorites');
//         }
//       } else {
//         const response = await fetch('https://propertydealstalk.com/api/buyer/addFavorites', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             buyer_id: user?.id,
//             property_id: parseInt(property?.id || propertyId)
//           })
//         });

//         const data = await response.json();

//         if (data.statusCode === 200) {
//           setIsFavorite(true);
//           setToast({
//             open: true,
//             message: 'Property added to favorites successfully',
//             severity: 'success'
//           });
//           console.log('✅ Property added to favorites');
//         } else {
//           throw new Error(data.message || 'Failed to add property to favorites');
//         }
//       }
//     } catch (err) {
//       console.error('Error toggling favorite:', err);
//       setToast({
//         open: true,
//         message: err.message || 'Failed to update favorites',
//         severity: 'error'
//       });
//     }
//   };

//   const handleShareClick = () => {
//     const publicUrl = `${window.location.origin}/view/${property?.id || propertyId}?shared=true`;
//     setShareUrl(publicUrl);
//     setShareDialog(true);
//   };

//   const handleCopyUrl = async () => {
//     try {
//       await navigator.clipboard.writeText(shareUrl);
//       setToast({
//         open: true,
//         message: 'URL copied to clipboard!',
//         severity: 'success'
//       });
//     } catch (err) {
//       console.error('Failed to copy URL:', err);
//       setToast({
//         open: true,
//         message: 'Failed to copy URL',
//         severity: 'error'
//       });
//     }
//   };

//   const handleCloseShareDialog = () => {
//     setShareDialog(false);
//   };

//   const handleCloseToast = (event, reason) => {
//     if (reason === 'clickaway') {
//       return;
//     }
//     setToast(prev => ({ ...prev, open: false }));
//   };

//   const fetchSimilarProperties = async (propId) => {
//     if (!propId) return;

//     setLoadingSimilar(true);
//     try {
//       const response = await fetch(`https://propertydealstalk.com/api/property/getSimilarProperties?property_id=${propId}`);

//       if (!response.ok) {
//         throw new Error('Failed to fetch similar properties');
//       }

//       const data = await response.json();

//       if (data.statusCode === 200 && data.result && data.result.similar_properties) {
//         setSimilarProperties(data.result.similar_properties.slice(0, 5));
//       } else {
//         console.warn('No similar properties found or invalid response format');
//         setSimilarProperties([]);
//       }
//     } catch (err) {
//       console.error('Error fetching similar properties:', err);
//       setSimilarProperties([]);
//     } finally {
//       setLoadingSimilar(false);
//     }
//   };

//   useEffect(() => {
//     setLoading(true);
//     setError(null);
//     setProperty(null);
//     setPropertyMedia([]);
//     setSelectedMediaIndex(0);
//     setSellerDetails(null);

//     const fetchPropertyDetails = async () => {
//       try {
//         const apiUrl = propertyId
//           ? `https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}`
//           : 'https://propertydealstalk.com/api/property/getProperties';

//         console.log('🌐 Fetching property from:', apiUrl);
//         const response = await fetch(apiUrl);

//         if (!response.ok) {
//           throw new Error('Failed to fetch property details');
//         }

//         const data = await response.json();
//         console.log('📦 Property API Response:', data);

//         if (data.statusCode === 200) {
//           const propertyList = Array.isArray(data.result) ? data.result : [data.result];
//           let selectedProperty;

//           if (propertyId) {
//             selectedProperty = Array.isArray(propertyList)
//               ? propertyList.find(p => p && p.id === parseInt(propertyId))
//               : propertyList;

//             if (!selectedProperty && propertyList.length > 0) {
//               selectedProperty = propertyList[0];
//             }
//           } else if (propertyList.length > 0) {
//             selectedProperty = propertyList[0];
//           }

//           if (selectedProperty) {
//             console.log('=== PROPERTY DETAILS ===');
//             console.log('Property:', selectedProperty);
//             console.log('Asset Type:', selectedProperty.asset_type);
//             console.log('Carpet Area:', selectedProperty.carpet_area);
//             console.log('Built-up Area:', selectedProperty.built_up_area);
//             console.log('UDS:', selectedProperty.uds);
//             console.log('Property Size:', selectedProperty.property_size);
//             console.log('Length:', selectedProperty.length);
//             console.log('Width:', selectedProperty.width);
//             console.log('Zone Type:', selectedProperty.zone_type);
            
//             setProperty(selectedProperty);
//             const processedMedia = processMedia(selectedProperty);
//             setPropertyMedia(processedMedia);

//             setInquiryDialog(prev => ({
//               ...prev,
//               propertyId: selectedProperty.id,
//               propertyTitle: selectedProperty.property_name
//             }));

//             if (selectedProperty.seller && selectedProperty.seller.full_name) {
//               console.log('✅ Using seller data from API response');
//               setSellerDetails(selectedProperty.seller);
//             } else if (selectedProperty.added_by_admin && selectedProperty.admin_id) {
//               console.log('🔄 Property added by admin, fetching admin details...');
//               await fetchAdminDetails(selectedProperty.admin_id);
//             } else if (selectedProperty.seller_id) {
//               console.log('🔄 Fetching seller details for seller_id:', selectedProperty.seller_id);
//               await fetchSellerDetails(selectedProperty.seller_id);
//             } else {
//               console.log('⚠️ No seller or admin information available');
//               setSellerDetails({
//                 full_name: 'Property Owner',
//                 contact_number: '+91 XXXXXXXXXX',
//                 email_id: 'contact@propertydealstalk.com',
//                 profile_image: avatarIcon,
//                 role: 'unknown'
//               });
//             }

//             fetchSimilarProperties(selectedProperty.id);

//             if (isLoggedIn && user?.id && !isSharedView) {
//               checkFavoriteStatus(selectedProperty.id);
//             }
//           } else {
//             throw new Error('Property not found');
//           }
//         } else {
//           throw new Error(data.message || 'Failed to fetch property details');
//         }
//       } catch (err) {
//         setError(err.message);
//         console.error('Error fetching property:', err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPropertyDetails();
//   }, [propertyId, isLoggedIn, user?.id, isSharedView]);

//   useEffect(() => {
//     const handleStorageChange = (e) => {
//       if (e.key === 'profile_updated' && e.newValue === 'true') {
//         console.log('Profile update detected in TalkView, refreshing seller details...');
        
//         if (property?.seller_id) {
//           fetchSellerDetails(property.seller_id);
//         } else if (property?.added_by_admin && property?.admin_id) {
//           fetchAdminDetails(property.admin_id);
//         }
        
//         localStorage.removeItem('profile_updated');
//       }
//     };

//     window.addEventListener('storage', handleStorageChange);
    
//     const intervalId = setInterval(() => {
//       if (localStorage.getItem('profile_updated') === 'true') {
//         console.log('Profile update detected (same tab), refreshing seller details...');
        
//         if (property?.seller_id) {
//           fetchSellerDetails(property.seller_id);
//         } else if (property?.added_by_admin && property?.admin_id) {
//           fetchAdminDetails(property.admin_id);
//         }
        
//         localStorage.removeItem('profile_updated');
//       }
//     }, 500);

//     return () => {
//       window.removeEventListener('storage', handleStorageChange);
//       clearInterval(intervalId);
//     };
//   }, [property?.seller_id, property?.admin_id, property?.added_by_admin]);

//   const handleSimilarPropertyClick = (propertyId) => {
//     const sharedParam = isSharedView ? '?shared=true' : '';
//     window.history.pushState({}, '', `/view/${propertyId}${sharedParam}`);

//     setLoading(true);
//     setError(null);
//     setProperty(null);
//     setPropertyMedia([]);
//     setSelectedMediaIndex(0);
//     setSimilarProperties([]);
//     setSellerDetails(null);
//     setIsFavorite(false);

//     const fetchPropertyDetails = async () => {
//       try {
//         const apiUrl = `https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}`;
//         const response = await fetch(apiUrl);

//         if (!response.ok) {
//           throw new Error('Failed to fetch property details');
//         }

//         const data = await response.json();

//         if (data.statusCode === 200) {
//           const propertyList = Array.isArray(data.result) ? data.result : [data.result];
//           let selectedProperty;

//           selectedProperty = Array.isArray(propertyList)
//             ? propertyList.find(p => p && p.id === parseInt(propertyId))
//             : propertyList;

//           if (!selectedProperty && propertyList.length > 0) {
//             selectedProperty = propertyList[0];
//           }

//           if (selectedProperty) {
//             setProperty(selectedProperty);
//             const processedMedia = processMedia(selectedProperty);
//             setPropertyMedia(processedMedia);

//             setInquiryDialog(prev => ({
//               ...prev,
//               propertyId: selectedProperty.id,
//               propertyTitle: selectedProperty.property_name
//             }));

//             if (selectedProperty.seller && selectedProperty.seller.full_name) {
//               setSellerDetails(selectedProperty.seller);
//             } else if (selectedProperty.added_by_admin && selectedProperty.admin_id) {
//               await fetchAdminDetails(selectedProperty.admin_id);
//             } else if (selectedProperty.seller_id) {
//               await fetchSellerDetails(selectedProperty.seller_id);
//             }

//             fetchSimilarProperties(selectedProperty.id);

//             if (isLoggedIn && !isSharedView) {
//               checkFavoriteStatus(selectedProperty.id);
//             }
//           } else {
//             throw new Error('Property not found');
//           }
//         } else {
//           throw new Error(data.message || 'Failed to fetch property details');
//         }
//       } catch (err) {
//         setError(err.message);
//         console.error('Error fetching property:', err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPropertyDetails();
//     window.scrollTo(0, 0);
//   };

//   const handleOpenInquiry = () => {
//     if (!isLoggedIn) {
//       navigate('/login');
//       return;
//     }

//     setInquiryDialog(prev => ({
//       ...prev,
//       open: true
//     }));
//   };

//   const handleCloseInquiry = () => {
//     setInquiryDialog(prev => ({
//       ...prev,
//       open: false
//     }));
//   };

//   const handleMediaSelect = (index) => {
//     setSelectedMediaIndex(index);
//   };

//   const handleOpenModal = (index) => {
//     setSelectedMediaIndex(index);
//     setModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setModalOpen(false);
//   };

//   const handleModalNavigation = (direction) => {
//     if (direction === 'next') {
//       setSelectedMediaIndex((prev) => (prev + 1) % propertyMedia.length);
//     } else {
//       setSelectedMediaIndex((prev) => (prev - 1 + propertyMedia.length) % propertyMedia.length);
//     }
//   };

//   const formatPrice = (price) => {
//     return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || '';
//   };

//   const parseAmenities = (property) => {
//     if (!property) return [];

//     const amenitiesList = [];

//     if (property.society_aminities) {
//       const societyAmenities = property.society_aminities.split(',').map(item => item.trim());
//       amenitiesList.push(...societyAmenities);
//     }

//     if (property.furnish_facilities) {
//       const furnishFacilities = property.furnish_facilities.split(',').map(item => item.trim());
//       amenitiesList.push(...furnishFacilities);
//     }

//     if (property.other_facilities) {
//       const otherFacilities = property.other_facilities.split(',').map(item => item.trim());
//       amenitiesList.push(...otherFacilities);
//     }

//     return [...new Set(amenitiesList)];
//   };

//   if (loading || !property) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   const allAmenities = parseAmenities(property);

//   // ✅ DETERMINE PROPERTY TYPE
//   const assetTypeLower = (property.asset_type || '').toLowerCase().trim();
//   const isApartment = assetTypeLower === 'apartment';
//   const isIndependentHouse = assetTypeLower === 'independent house';
//   const isPentHouse = assetTypeLower === 'pent house' || assetTypeLower === 'penthouse';
//   const isStudio = assetTypeLower === 'studio';
//   const isVilla = assetTypeLower === 'villa';
//   const isPlot = assetTypeLower === 'plot';
//   const isAgricultureLand = assetTypeLower === 'agriculture land';
//   const isFarmhouse = assetTypeLower === 'farm house' || assetTypeLower === 'farmhouse';
//   const isCommercial = property.property_type === 'commercial';
//   const isOffice = assetTypeLower === 'office';
//   const isShowroom = assetTypeLower === 'showroom';
//   const isRetailShop = assetTypeLower === 'retail shop';
//   const isWarehouse = assetTypeLower === 'warehouse' || assetTypeLower === 'ware house';

//   console.log('🏠 Property Type Detection:', {
//     assetTypeLower,
//     isApartment,
//     isIndependentHouse,
//     isPentHouse,
//     isStudio,
//     isVilla,
//     isPlot,
//     isAgricultureLand,
//     isFarmhouse,
//     isCommercial,
//     isOffice,
//     isShowroom,
//     isRetailShop,
//     isWarehouse
//   });

//   const shouldShowAmenities = () => {
//     return isFarmhouse || isVilla || (!isCommercial && !isPlot && !isAgricultureLand);
//   };

//   const builtYear = property.age_of_property
//     ? (new Date().getFullYear() - property.age_of_property)
//     : 'Not specified';

//   // ✅ GET PROPERTY DETAILS FOR TOP SECTION (BHK, Floor, Size)
//   const getPropertyDetails = () => {
//     const details = [];

//     // BHK (for applicable types)
//     if (hasValue(property.bhk) && !isPlot && !isAgricultureLand && !isCommercial) {
//       details.push({ type: 'BHK', value: `${property.bhk} BHK` });
//     }

//     // Floor (for applicable types)
//     if (hasValue(property.select_floor) && hasValue(property.total_floors) && !isPlot && !isAgricultureLand) {
//       details.push({ type: 'Floor', value: `${property.select_floor}/${property.total_floors} Floor` });
//     }

//     // Size - prioritize based on property type
//     if (isApartment && hasValue(property.carpet_area)) {
//       const unit = hasValue(property.carpet_area_units) ? property.carpet_area_units : 'Sq.Ft';
//       details.push({ type: 'Size', value: `${property.carpet_area} ${unit}` });
//     } else if ((isIndependentHouse || isStudio || isVilla || isFarmhouse || isCommercial) && hasValue(property.property_size)) {
//       const unit = hasValue(property.property_size_units) ? property.property_size_units : 'Sq.Ft';
//       details.push({ type: 'Size', value: `${property.property_size} ${unit}` });
//     } else if (isPentHouse && hasValue(property.built_up_area)) {
//       const unit = hasValue(property.built_up_area_units) ? property.built_up_area_units : 'Sq.Ft';
//       details.push({ type: 'Size', value: `${property.built_up_area} ${unit}` });
//     } else if ((isPlot || isAgricultureLand) && hasValue(property.property_size)) {
//       const unit = hasValue(property.property_size_units) ? property.property_size_units : 'Sq.Yards';
//       details.push({ type: 'Size', value: `${property.property_size} ${unit}` });
//     }

//     return details;
//   };

//   const propertyDetails = getPropertyDetails();

//   const getDisplayPrice = () => {
//     const category = property.category || property.commercial_catgory || '';
//     const isRental = category.toLowerCase() === 'rent';

//     if (isRental) {
//       if (hasValue(property.monthly_rent) && property.monthly_rent !== 0) {
//         return property.monthly_rent;
//       }
//     }

//     if (hasValue(property.asking_price) && property.asking_price !== 0) {
//       return property.asking_price;
//     }

//     return null;
//   };

//   const displayPrice = getDisplayPrice();
//   const isRentalProperty = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';

//   const shouldShowContactInfo = isLoggedIn && !isSharedView;

//   const sellerName = shouldShowContactInfo 
//     ? (sellerDetails?.full_name || "Property Owner")
//     : "Seller";
  
//   const sellerContact = shouldShowContactInfo 
//     ? (sellerDetails?.contact_number || "+91 XXXXXXXXXX")
//     : '+91 123*****89';
  
//   const sellerEmail = shouldShowContactInfo 
//     ? (sellerDetails?.email_id || "seller@example.com")
//     : 'Seller*****@gmail.com';
  
//   const sellerImage = sellerDetails?.profile_image || avatarIcon;

//   // ✅ REUSABLE COMPONENTS FOR SECTIONS
  
//   // Main Media Display Component
//   const MainMediaDisplay = () => (
//     <Box sx={{ position: 'relative', width: '100%', height: isMobile ? 250 : 450 }}>
//       {propertyMedia.length > 0 ? (
//         <>
//           {propertyMedia[selectedMediaIndex].type === 'image' ? (
//             <Box
//               component="img"
//               src={propertyMedia[selectedMediaIndex].src}
//               alt={property.property_name}
//               sx={{
//                 width: '100%',
//                 height: '100%',
//                 objectFit: 'cover',
//                 borderRadius: 2,
//                 cursor: 'pointer'
//               }}
//               onClick={() => handleOpenModal(selectedMediaIndex)}
//             />
//           ) : (
//             <Box
//               sx={{
//                 width: '100%',
//                 height: '100%',
//                 bgcolor: '#000',
//                 borderRadius: 2,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 cursor: 'pointer',
//                 position: 'relative'
//               }}
//               onClick={() => handleOpenModal(selectedMediaIndex)}
//             >
//               <video
//                 src={propertyMedia[selectedMediaIndex].src}
//                 style={{
//                   width: '100%',
//                   height: '100%',
//                   objectFit: 'cover',
//                   borderRadius: 2
//                 }}
//               />
//               <PlayArrowIcon
//                 sx={{
//                   position: 'absolute',
//                   color: 'white',
//                   fontSize: 60,
//                   opacity: 0.8
//                 }}
//               />
//             </Box>
//           )}
//         </>
//       ) : (
//         <Box
//           sx={{
//             width: '100%',
//             height: '100%',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             backgroundColor: '#f5f5f5',
//             borderRadius: 2,
//             border: '1px dashed #ccc'
//           }}
//         >
//           <Typography variant="h6" color="#888" textAlign="center">
//             No images uploaded
//           </Typography>
//         </Box>
//       )}

//       {propertyMedia.length > 1 && (
//         <Box
//           sx={{
//             position: 'absolute',
//             top: 16,
//             right: 16,
//             bgcolor: 'rgba(0,0,0,0.7)',
//             color: 'white',
//             padding: '4px 12px',
//             borderRadius: 2,
//             fontSize: 14
//           }}
//         >
//           {selectedMediaIndex + 1} / {propertyMedia.length}
//         </Box>
//       )}

//       {propertyMedia.length > 1 && (
//         <>
//           <IconButton
//             sx={{
//               position: 'absolute',
//               left: 16,
//               top: '50%',
//               transform: 'translateY(-50%)',
//               bgcolor: 'rgba(255,255,255,0.9)',
//               '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
//             }}
//             onClick={(e) => {
//               e.stopPropagation();
//               handleMediaSelect((selectedMediaIndex - 1 + propertyMedia.length) % propertyMedia.length);
//             }}
//           >
//             <Typography variant="h6" sx={{ color: '#000' }}>‹</Typography>
//           </IconButton>
//           <IconButton
//             sx={{
//               position: 'absolute',
//               right: 16,
//               top: '50%',
//               transform: 'translateY(-50%)',
//               bgcolor: 'rgba(255,255,255,0.9)',
//               '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
//             }}
//             onClick={(e) => {
//               e.stopPropagation();
//               handleMediaSelect((selectedMediaIndex + 1) % propertyMedia.length);
//             }}
//           >
//             <Typography variant="h6" sx={{ color: '#000' }}>›</Typography>
//           </IconButton>
//         </>
//       )}
//     </Box>
//   );

//   // Media Thumbnails Component
//   const MediaThumbnails = () => (
//     <>
//       {propertyMedia.length > 1 && (
//         <Box
//           sx={{
//             display: 'flex',
//             gap: 2,
//             mt: 2,
//             overflowX: 'auto',
//             pb: 1,
//             '&::-webkit-scrollbar': {
//               height: 4,
//             },
//             '&::-webkit-scrollbar-track': {
//               background: '#f1f1f1',
//             },
//             '&::-webkit-scrollbar-thumb': {
//               background: '#888',
//               borderRadius: 2,
//             },
//           }}
//         >
//           {propertyMedia.map((media, index) => (
//             <Box
//               key={index}
//               sx={{
//                 position: 'relative',
//                 minWidth: 80,
//                 height: 80,
//                 borderRadius: 2,
//                 overflow: 'hidden',
//                 cursor: 'pointer',
//                 border: selectedMediaIndex === index ? '3px solid #2563EB' : '2px solid #ddd',
//                 opacity: selectedMediaIndex === index ? 1 : 0.7,
//                 transition: 'all 0.2s ease',
//                 '&:hover': {
//                   opacity: 1,
//                   transform: 'scale(1.05)'
//                 }
//               }}
//               onClick={() => handleMediaSelect(index)}
//             >
//               {media.type === 'image' ? (
//                 <Box
//                   component="img"
//                   src={media.src}
//                   alt={`Thumbnail ${index + 1}`}
//                   sx={{
//                     width: '100%',
//                     height: '100%',
//                     objectFit: 'cover'
//                   }}
//                 />
//               ) : (
//                 <Box
//                   sx={{
//                     width: '100%',
//                     height: '100%',
//                     bgcolor: '#000',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center'
//                   }}
//                 >
//                   <PlayArrowIcon sx={{ color: 'white', fontSize: 24 }} />
//                 </Box>
//               )}
//               {media.type === 'video' && (
//                 <Box
//                   sx={{
//                     position: 'absolute',
//                     top: 4,
//                     right: 4,
//                     bgcolor: 'rgba(0,0,0,0.7)',
//                     borderRadius: '50%',
//                     width: 20,
//                     height: 20,
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center'
//                   }}
//                 >
//                   <PlayArrowIcon sx={{ color: 'white', fontSize: 12 }} />
//                 </Box>
//               )}
//             </Box>
//           ))}
//         </Box>
//       )}
//     </>
//   );

//   // Price Section Component
//   const PriceSection = () => (
//     <Box
//       bgcolor="#fff"
//       p={3}
//       borderRadius={2}
//       mb={3}
//       height={isMobile ? 'auto' : 'auto'}
//       display="flex"
//       flexDirection="column"
//     >
//       <Typography color="#2563EB" fontstyle="semibold" fontSize={22} fontWeight={600}>
//         {displayPrice && displayPrice !== 0 ? (
//           <>
//             {property.currency || '₹'}{formatPrice(displayPrice)}
//             {isRentalProperty && ' /month'}
//           </>
//         ) : (
//           'Price on Request'
//         )}
//       </Typography>

//       <Typography fontSize={17} my={1.5} fontWeight={600}>
//         {property.property_name}
//       </Typography>

//       <Box display="flex" alignItems="center" gap={1} fontSize={14} fontWeight={400} color="#555" mb={1}>
//         <LocationOnIcon sx={{ fontSize: 16, color: '#666' }} />
//         {property.location}, {property.area_name}
//       </Box>

//       <Box display="flex" justifyContent="space-between" my={1} fontWeight={400} fontSize={13.5} color="#666">
//         <Box display="flex" alignItems="center" gap={1}>
//           <img src={calendarIcon} alt="Calendar" width={16} height={17} />
//           {new Date(property.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
//         </Box>
//       </Box>

//       {propertyDetails.length > 0 && (
//         <Box display="flex" gap={isMobile ? 4 : 8} flexWrap="wrap" my={2} justifyContent="space-between">
//           {propertyDetails.map((detail, index) => (
//             <Box key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//               <Box sx={{ color: '#666', fontSize: 30, height: 40, display: 'flex', alignItems: 'center' }}>
//                 {getAmenityIcon(detail.type)}
//               </Box>
//               <Typography fontSize={14}>{detail.value}</Typography>
//             </Box>
//           ))}
//         </Box>
//       )}

//       <hr style={{ margin: '8px 0', border: 'none', borderTop: '1px solid #eee' }} />

//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="subtitle1" fontSize={17} fontWeight={600} color="#000000">
//           Contact Seller
//         </Typography>
//         {shouldShowContactInfo && (
//           <Button
//             variant="text"
//             sx={{ p: 0, minWidth: 'auto' }}
//             onClick={handleOpenInquiry}
//           >
//             <img src={contactim} alt="Contact" style={{ height: 40 }} />
//           </Button>
//         )}
//       </Box>

//       <Box display="flex" alignItems="center" gap={3} mt={1}>
//         <Avatar
//           src={sellerImage}
//           sx={{ width: 57, height: 62 }}
//         />
//         <Box>
//           <Typography fontSize={15} fontWeight={500} color="#000000">
//             {sellerName}
//           </Typography>
//           <Typography fontSize={13} color="blue" fontWeight={400}>
//             {sellerContact}
//           </Typography>
//           <Typography fontSize={15} color="#000000" fontWeight={500}>
//             {sellerEmail}
//           </Typography>
//         </Box>
//       </Box>

//       <hr style={{ margin: '12px 0', border: 'none', borderTop: '1px solid #eee' }} />

//       {shouldShowContactInfo && (
//         <Box display="flex" gap={3} mt={2} alignItems="center">
//           <Box
//             display="flex"
//             alignItems="center"
//             gap={1}
//             sx={{ cursor: 'pointer' }}
//             onClick={toggleFavorite}
//           >
//             {isFavorite ? (
//               <FavoriteIcon sx={{ color: 'red', fontSize: 32 }} />
//             ) : (
//               <FavoriteBorderIcon sx={{ color: '#666', fontSize: 32 }} />
//             )}
//             <Typography fontSize={14} fontWeight={500} color="#000">
//               {isFavorite ? 'Saved' : 'Save'}
//             </Typography>
//           </Box>

//           <Box
//             display="flex"
//             alignItems="center"
//             gap={1}
//             sx={{ cursor: 'pointer' }}
//             onClick={handleShareClick}
//           >
//             <ShareIcon sx={{ color: '#666', fontSize: 28 }} />
//             <Typography fontSize={14} fontWeight={500} color="#000">
//               Share
//             </Typography>
//           </Box>
//         </Box>
//       )}
//     </Box>
//   );

//   // ✅ DESCRIPTION BOX WITH CONDITIONAL FIELD DISPLAY
//   const DescriptionBox = () => (
//     <Box mt={isMobile ? 0 : 4} bgcolor="#fff" p={3} borderRadius={2}>
//       {/* Description */}
//       {hasValue(property.description) && (
//         <>
//           <Typography variant="h6" mb={2}>Property Description</Typography>
//           <Typography fontSize={14} color="#626262" mb={2}>
//             {property.description}
//           </Typography>
//         </>
//       )}

//       {/* Additional Content */}
//       {hasValue(property.content) && (
//         <>
//           <Typography variant="h6" mb={2} mt={hasValue(property.description) ? 3 : 0}>
//             Additional Content
//           </Typography>
//           <Typography fontSize={14} color="#626262" mb={2}>
//             {property.content}
//           </Typography>
//         </>
//       )}

//       {/* Complete Address */}
//       {hasValue(property.full_address) && (
//         <>
//           <Typography variant="h6" mb={2} mt={3}>Complete Address</Typography>
//           <Typography fontSize={14} color="#626262" mb={2}>
//             {property.full_address}
//           </Typography>
//         </>
//       )}

//       {/* ✅ AREA DETAILS SECTION - CONDITIONAL BY PROPERTY TYPE */}
// {(isApartment || isIndependentHouse || isPentHouse || isStudio || isVilla || isFarmhouse || isCommercial) && (
//   <>
//     <Typography variant="subtitle1" mt={3} mb={2} fontWeight={500}>
//       Area Details
//     </Typography>
    
//     {/* ✅ APARTMENT: carpet_area, built_up_area, uds (optional) */}
//     {isApartment && (
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         {hasValue(property.carpet_area) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Carpet Area')}
//               <span>Carpet Area</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.carpet_area} {property.carpet_area_units || 'Sq.Ft'}
//             </Box>
//           </Box>
//         )}
//         {hasValue(property.built_up_area) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Built-up Area')}
//               <span>Built-up Area</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
//             </Box>
//           </Box>
//         )}
//         {hasValue(property.uds) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('UDS')}
//               <span>UDS</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.uds} {property.uds_units || 'Sq.Yards'}
//             </Box>
//           </Box>
//         )}
//       </Box>
//     )}

//     {/* ✅ INDEPENDENT HOUSE: built_up_area, property_size, uds (optional) */}
//     {isIndependentHouse && (
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         {hasValue(property.built_up_area) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Built-up Area')}
//               <span>Built-up Area</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
//             </Box>
//           </Box>
//         )}
//         {hasValue(property.property_size) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Property Size')}
//               <span>Property Size</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.property_size} {property.property_size_units || 'Sq.Ft'}
//             </Box>
//           </Box>
//         )}
//         {hasValue(property.uds) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('UDS')}
//               <span>UDS</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.uds} {property.uds_units || 'Sq.Yards'}
//             </Box>
//           </Box>
//         )}
//       </Box>
//     )}

//     {/* ✅ PENT HOUSE: built_up_area ONLY */}
//     {isPentHouse && (
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         {hasValue(property.built_up_area) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Built-up Area')}
//               <span>Built-up Area</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
//             </Box>
//           </Box>
//         )}
//       </Box>
//     )}

//     {/* ✅ STUDIO: property_size */}
//     {isStudio && (
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         {hasValue(property.property_size) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Property Size')}
//               <span>Property Size</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.property_size} {property.property_size_units || 'Sq.Ft'}
//             </Box>
//           </Box>
//         )}
//       </Box>
//     )}

//     {/* ✅ VILLA: built_up_area, property_size */}
//     {isVilla && (
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         {hasValue(property.built_up_area) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Built-up Area')}
//               <span>Built-up Area</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
//             </Box>
//           </Box>
//         )}
//         {hasValue(property.property_size) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Property Size')}
//               <span>Property Size</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.property_size} {property.property_size_units || 'Sq.Ft'}
//             </Box>
//           </Box>
//         )}
//       </Box>
//     )}

//     {/* ✅ FARMHOUSE: built_up_area, property_size (ONLY if NOT commercial) */}
//     {isFarmhouse && !isCommercial && (
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         {hasValue(property.built_up_area) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Built-up Area')}
//               <span>Built-up Area</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
//             </Box>
//           </Box>
//         )}
//         {hasValue(property.property_size) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Property Size')}
//               <span>Property Size</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.property_size} {property.property_size_units || 'Acres'}
//             </Box>
//           </Box>
//         )}
//       </Box>
//     )}

//     {/* ✅ COMMERCIAL PROPERTIES (including Commercial Farmhouse) */}
//     {isCommercial && (
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//         {hasValue(property.built_up_area) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Built-up Area')}
//               <span>Built-up Area</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
//             </Box>
//           </Box>
//         )}
//         {hasValue(property.property_size) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Property Size')}
//               <span>Property Size</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.property_size} {property.property_size_units || (isFarmhouse ? 'Acres' : 'Sq.Ft')}
//             </Box>
//           </Box>
//         )}
//         {hasValue(property.carpet_area) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Carpet Area')}
//               <span>Carpet Area</span>
//             </Box>
//             <Box fontWeight="bold">
//               {property.carpet_area} {property.carpet_area_units || 'Sq.Ft'}
//             </Box>
//           </Box>
//         )}
//         {hasValue(property.zone_type) && (
//           <Box display="flex" gap={3} fontSize={14} color="#626262">
//             <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//               {getAmenityIcon('Zone Type')}
//               <span>Zone Type</span>
//             </Box>
//             <Box fontWeight="bold">{property.zone_type}</Box>
//           </Box>
//         )}
//       </Box>
//     )}
//   </>
// )}

//       {/* ✅ PLOT & AGRICULTURE LAND: property_size, zone_type, length, width */}
//       {(isPlot || isAgricultureLand) && (
//         <>
//           <Typography variant="subtitle1" mt={3} mb={2} fontWeight={500}>
//             Plot Details
//           </Typography>
//           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//             {hasValue(property.property_size) && (
//               <Box display="flex" gap={3} fontSize={14} color="#626262">
//                 <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//                   {getAmenityIcon('Property Size')}
//                   <span>Property Size</span>
//                 </Box>
//                 <Box fontWeight="bold">
//                   {property.property_size} {property.property_size_units || 'Sq.Yards'}
//                 </Box>
//               </Box>
//             )}
//             {hasValue(property.zone_type) && (
//               <Box display="flex" gap={3} fontSize={14} color="#626262">
//                 <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//                   {getAmenityIcon('Zone Type')}
//                   <span>Zone Type</span>
//                 </Box>
//                 <Box fontWeight="bold">{property.zone_type}</Box>
//               </Box>
//             )}
//             {!isAgricultureLand && hasValue(property.length) && (
//               <Box display="flex" gap={3} fontSize={14} color="#626262">
//                 <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//                   {getAmenityIcon('Length')}
//                   <span>Length</span>
//                 </Box>
//                 <Box fontWeight="bold">
//                   {property.length} {property.length_units || 'Feet'}
//                 </Box>
//               </Box>
//             )}
//             {!isAgricultureLand && hasValue(property.width) && (
//               <Box display="flex" gap={3} fontSize={14} color="#626262">
//                 <Box minWidth={150} display="flex" alignItems="center" gap={1}>
//                   {getAmenityIcon('Width')}
//                   <span>Width</span>
//                 </Box>
//                 <Box fontWeight="bold">
//                   {property.width} {property.width_units || 'Feet'}
//                 </Box>
//               </Box>
//             )}
//           </Box>
//         </>
//       )}

//       {/* Features & Amenities */}
//       {shouldShowAmenities() && allAmenities.length > 0 && (
//         <>
//           <Typography variant="subtitle1" mb={2} mt={3} fontWeight={500}>
//             Features & Amenities
//           </Typography>
//           <Box
//             sx={{
//               display: 'grid',
//               gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
//               columnGap: 4,
//               rowGap: 2,
//             }}
//           >
//             {allAmenities.map((amenity, index) => (
//               <Box key={index} display="flex" alignItems="center" gap={1} fontSize={14} fontWeight="bold">
//                 {getAmenityIcon(amenity)}
//                 {amenity}
//               </Box>
//             ))}
//           </Box>
//         </>
//       )}

//       {/* Additional Details */}
//       <Typography variant="subtitle1" mt={3} fontWeight={500}>Additional Details</Typography>
//       <Box mt={1}>
//         <Box
//           display="flex"
//           flexWrap="wrap"
//           alignItems="center"
//           gap={isMobile ? 1 : 3}
//           mb={1}
//           fontSize={14}
//           color="#626262"
//           fontWeight={400}
//         >
//           <Box minWidth={130}>Property Type</Box>
//           <Box fontWeight="bold">{property.property_type} {property.asset_type}</Box>
//         </Box>

//         <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//           <Box minWidth={130}>Property ID</Box>
//           <Box fontWeight="bold">#{property.id}</Box>
//         </Box>

//         {hasValue(property.negotiable) && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Price Negotiable</Box>
//             <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
//               {property.negotiable === 'true' || property.negotiable === true ? 'Yes' : 'No'}
//             </Box>
//           </Box>
//         )}

//         {hasValue(property.total_floors) && !isPlot && !isAgricultureLand && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Total Floors</Box>
//             <Box fontWeight="bold">{property.total_floors}</Box>
//           </Box>
//         )}

//         {hasValue(property.select_floor) && !isPlot && !isAgricultureLand && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Floor Number</Box>
//                         <Box fontWeight="bold">{property.select_floor}</Box>
//           </Box>
//         )}

//         {hasValue(property.furnish_type) && !isPlot && !isAgricultureLand && !isCommercial && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Furnishing</Box>
//             <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
//               {getFurnishingTypeName(property.furnish_type)}
//             </Box>
//           </Box>
//         )}

//         {hasValue(property.construction_status) && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Construction Status</Box>
//             <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
//               {property.construction_status}
//             </Box>
//           </Box>
//         )}

//         {hasValue(property.monthly_rent) && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Monthly Rent</Box>
//             <Box fontWeight="bold">
//               {property.currency || '₹'}{formatPrice(property.monthly_rent)}
//             </Box>
//           </Box>
//         )}

//         {hasValue(property.security_deposit) && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Security Deposit</Box>
//             <Box fontWeight="bold">{property.security_deposit}</Box>
//           </Box>
//         )}

//         {hasValue(property.available_from) && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Available From</Box>
//             <Box fontWeight="bold">
//               {new Date(property.available_from).toLocaleDateString('en-US', {
//                 month: 'long',
//                 day: 'numeric',
//                 year: 'numeric'
//               })}
//             </Box>
//           </Box>
//         )}

//         {hasValue(property.ownership) && (isPlot || isAgricultureLand || isCommercial) && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Ownership</Box>
//             <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
//               {property.ownership}
//             </Box>
//           </Box>
//         )}

//         {hasValue(property.hub) && isCommercial && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Hub</Box>
//             <Box fontWeight="bold">{property.hub}</Box>
//           </Box>
//         )}

//         {hasValue(property.commercial_catgory) && isCommercial && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Category</Box>
//             <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
//               {property.commercial_catgory}
//             </Box>
//           </Box>
//         )}

//         {hasValue(property.youtube_link) && property.youtube_link !== "null" && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Social media Link</Box>
//             <Box fontWeight="bold" sx={{ wordBreak: 'break-all' }}>
//               {shouldShowContactInfo ? (
//                 <a
//                   href={property.youtube_link.trim()}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   style={{
//                     color: '#2563EB',
//                     textDecoration: 'underline',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   {property.youtube_link.trim()}
//                 </a>
//               ) : (
//                 <span style={{ color: '#2563EB' }}>https://youtu.be/****</span>
//               )}
//             </Box>
//           </Box>
//         )}

//         {propertyMedia.some(media => media.type === 'video') && (
//           <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
//             <Box minWidth={130}>Property Video</Box>
//             <Box fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <img src={youtubeIcon} alt="Video" width={18} />
//               Available
//             </Box>
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );

//   // Similar Properties Component
//   const SimilarPropertiesSection = () => (
//     <Box bgcolor="#fff" p={3} borderRadius={2} mt={isMobile ? 3 : 0}>
//       <Typography variant="subtitle1" mb={2} fontWeight={600}>
//         Similar Properties
//       </Typography>
//       {loadingSimilar ? (
//         <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
//           <CircularProgress size={24} />
//         </Box>
//       ) : similarProperties.length === 0 ? (
//         <Typography color="#666">No similar properties found.</Typography>
//       ) : (
//         similarProperties.map((sim) => {
//           const simImageSrc = sim.image
//             ? `data:image/png;base64,${sim.image}`
//             : similarImg;

//           return (
//             <Box
//               key={sim.id}
//               display="flex"
//               alignItems="center"
//               gap={2}
//               mb={2}
//               sx={{
//                 cursor: 'pointer',
//                 transition: 'all 0.2s ease',
//                 '&:hover': {
//                   backgroundColor: '#f5f8ff',
//                   borderRadius: '8px'
//                 },
//                 p: 1
//               }}
//               onClick={() => handleSimilarPropertyClick(sim.id)}
//             >
//               <img
//                 src={simImageSrc}
//                 alt={sim.property_name || 'Similar Property'}
//                 width={60}
//                 height={60}
//                 style={{ borderRadius: 8, objectFit: 'cover' }}
//               />
//               <Box>
//                 <Typography fontSize={13} fontWeight={500}>
//                   {sim.property_name || `${sim.asset_type || ''} ${sim.property_type || ''}`}
//                 </Typography>
//                 <Typography fontSize={13} color="#2563EB" fontWeight={500}>
//                   {sim.currency || '₹'}
//                   {formatPrice(sim.asking_price)}
//                 </Typography>
//                 <Typography fontSize={12} color="#666">
//                   {sim.area_name ? `${sim.area_name}, ${sim.location}` : `${sim.location}`}
//                 </Typography>
//               </Box>
//             </Box>
//           );
//         })
//       )}
//     </Box>
//   );

//   return (
//     <Box
//       sx={{
//         background: '#f9f9f9',
//         fontFamily: 'Outfit, sans-serif',
//         px: isMobile ? 2 : 6,
//         py: isMobile ? 2 : 4,
//       }}
//     >
//       {/* ✅ CONDITIONAL LAYOUT: Mobile vs Desktop */}
//       {isMobile ? (
//         // ========== MOBILE LAYOUT ==========
//         <Box>
//           {/* Main Media Display */}
//           <MainMediaDisplay />
          
//           {/* Media Thumbnails */}
//           <MediaThumbnails />
          
//           {/* Price Section */}
//           <Box mt={3}>
//             <PriceSection />
//           </Box>
          
//           {/* Description Box */}
//           <Box mt={3}>
//             <DescriptionBox />
//           </Box>
          
//           {/* Similar Properties */}
//           <SimilarPropertiesSection />
//         </Box>
//       ) : (
//         // ========== DESKTOP LAYOUT ==========
//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'row',
//             gap: 4,
//           }}
//         >
//           {/* LEFT SECTION */}
//           <Box sx={{ flex: 1 }}>
//             {/* Main Media Display */}
//             <MainMediaDisplay />
            
//             {/* Media Thumbnails Gallery */}
//             <MediaThumbnails />
            
//             {/* Description Box */}
//             <DescriptionBox />
//           </Box>

//           {/* RIGHT SECTION */}
//           <Box sx={{ flex: 1, maxWidth: 420 }}>
//             {/* Price Section */}
//             <PriceSection />
            
//             {/* Similar Properties */}
//             <SimilarPropertiesSection />
//           </Box>
//         </Box>
//       )}

//       {/* Media Modal */}
//       <Modal
//         open={modalOpen}
//         onClose={handleCloseModal}
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           backdropFilter: 'blur(5px)'
//         }}
//       >
//         <Box sx={{ position: 'relative', maxWidth: '90vw', maxHeight: '90vh' }}>
//           <IconButton
//             sx={{
//               position: 'absolute',
//               top: 8,
//               right: 8,
//               bgcolor: 'rgba(0,0,0,0.5)',
//               color: 'white',
//               zIndex: 1000,
//               '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
//             }}
//             onClick={handleCloseModal}
//           >
//             <CloseIcon />
//           </IconButton>

//           {propertyMedia.length > 1 && (
//             <>
//               <IconButton
//                 sx={{
//                   position: 'absolute',
//                   left: 8,
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                   bgcolor: 'rgba(0,0,0,0.5)',
//                   color: 'white',
//                   zIndex: 1000,
//                   '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
//                 }}
//                 onClick={() => handleModalNavigation('prev')}
//               >
//                 <Typography variant="h6">‹</Typography>
//               </IconButton>
//               <IconButton
//                 sx={{
//                   position: 'absolute',
//                   right: 8,
//                   top: '50%',
//                   transform: 'translateY(-50%)',
//                   bgcolor: 'rgba(0,0,0,0.5)',
//                   color: 'white',
//                   zIndex: 1000,
//                   '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
//                 }}
//                 onClick={() => handleModalNavigation('next')}
//               >
//                 <Typography variant="h6">›</Typography>
//               </IconButton>
//             </>
//           )}

//           {propertyMedia[selectedMediaIndex]?.type === 'image' ? (
//             <Box
//               component="img"
//               src={propertyMedia[selectedMediaIndex].src}
//               alt={property.property_name}
//               sx={{
//                 maxWidth: '100%',
//                 maxHeight: '90vh',
//                 objectFit: 'contain'
//               }}
//             />
//           ) : (
//             <Box
//               sx={{
//                 width: '80vw',
//                 height: '80vh',
//                 bgcolor: '#000'
//               }}
//             >
//               <video
//                 src={propertyMedia[selectedMediaIndex]?.src}
//                 controls
//                 autoPlay
//                 style={{
//                   width: '100%',
//                   height: '100%',
//                   objectFit: 'contain'
//                 }}
//               />
//             </Box>
//           )}
//         </Box>
//       </Modal>

//       {/* Share Dialog */}
//       <Dialog
//         open={shareDialog}
//         onClose={handleCloseShareDialog}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <Typography variant="h6" fontWeight={600}>Share Property</Typography>
//           <IconButton onClick={handleCloseShareDialog} size="small">
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="#666" mb={2}>
//             Share this property link with others. Anyone with this link can view the property details.
//           </Typography>
//           <TextField
//             fullWidth
//             value={shareUrl}
//             InputProps={{
//               readOnly: true,
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton
//                     onClick={handleCopyUrl}
//                     edge="end"
//                     color="primary"
//                     title="Copy URL"
//                   >
//                     <ContentCopyIcon />
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//             variant="outlined"
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 backgroundColor: '#f5f5f5',
//               }
//             }}
//           />
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={handleCloseShareDialog} variant="outlined">
//             Close
//           </Button>
//           <Button onClick={handleCopyUrl} variant="contained" startIcon={<ContentCopyIcon />}>
//             Copy Link
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Toast Notification */}
//       <Snackbar
//         open={toast.open}
//         autoHideDuration={6000}
//         onClose={handleCloseToast}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%' }}>
//           {toast.message}
//         </Alert>
//       </Snackbar>

//       {/* Inquiry Dialog */}
//       <CreateInquiry
//         open={inquiryDialog.open}
//         onClose={handleCloseInquiry}
//         propertyId={inquiryDialog.propertyId}
//         buyerId={user?.id || 1}
//         propertyTitle={inquiryDialog.propertyTitle}
//       />
//     </Box>
//   );
// };

// export default TalkView;




import React, { useState, useEffect, useRef } from 'react'; // ✅ ADDED useRef
import {
  Box,
  Typography,
  Avatar,
  Button,
  useMediaQuery,
  CircularProgress,
  Modal,
  IconButton,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// ✅ ADDED: Socket imports
import socketService from '../../../services/socketService';
import socketEvents from '../../../services/socketEvents';

// Images
import avatarIcon from '../../../assets/prof.png';
import locationIcon from '../../../assets/loc.png';
import calendarIcon from '../../../assets/calendar.png';
import viewsIcon from '../../../assets/eye.png';
import saveIcon from '../../../assets/logsave.png';
import shareIcon from '../../../assets/logshare.png';
import youtubeIcon from '../../../assets/logicon.png';
import contactim from '../../../assets/conta.png';
import similarImg from '../../../assets/sideimg.jpg';

// Import Material UI icons for amenities
import BedIcon from '@mui/icons-material/Bed';
import BathtubIcon from '@mui/icons-material/Bathtub';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ElevatorIcon from '@mui/icons-material/Elevator';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import PoolIcon from '@mui/icons-material/Pool';
import PetsIcon from '@mui/icons-material/Pets';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import TvIcon from '@mui/icons-material/Tv';
import ChairIcon from '@mui/icons-material/Chair';
import KitchenIcon from '@mui/icons-material/Kitchen';
import WeekendIcon from '@mui/icons-material/Weekend';
import WifiIcon from '@mui/icons-material/Wifi';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import MicrowaveIcon from '@mui/icons-material/Microwave';
import PowerIcon from '@mui/icons-material/Power';
import SecurityIcon from '@mui/icons-material/Security';
import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import HouseIcon from '@mui/icons-material/House';
import ParkIcon from '@mui/icons-material/Park';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import TerrainIcon from '@mui/icons-material/Terrain';
import StraightenIcon from '@mui/icons-material/Straighten';

// Import the CreateInquiry component
import CreateInquiry from './CreateInquiry';

const TalkView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { propertyId } = useParams();
  const isMobile = useMediaQuery('(max-width:768px)');
  const user = useSelector((state) => state.user.user);
  const isLoggedIn = !!user?.token;
  const propertyIds = useSelector((state) => state.user.properties);

  const isSharedView = location.search.includes('shared=true');

  // ✅ ADDED: Socket initialization ref
  const socketInitializedRef = useRef(false);

  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [propertyMedia, setPropertyMedia] = useState([]);
  const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [sellerDetails, setSellerDetails] = useState(null);
  const [similarProperties, setSimilarProperties] = useState([]);
  const [loadingSimilar, setLoadingSimilar] = useState(false);
  const [inquiryDialog, setInquiryDialog] = useState({
    open: false,
    propertyId: propertyId ? parseInt(propertyId) : null,
    propertyTitle: ''
  });
  const [isFavorite, setIsFavorite] = useState(false);
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [shareDialog, setShareDialog] = useState(false);
  const [shareUrl, setShareUrl] = useState('');

  const hasValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed !== '' && trimmed !== 'null' && trimmed !== 'undefined' && trimmed !== 'N/A';
    }
    if (typeof value === 'number') return !isNaN(value) && value !== 0;
    return true;
  };

  const getFurnishingTypeName = (furnishType) => {
    if (!furnishType) return '';
    const furnishingMap = {
      'un': 'Unfurnished',
      'unfurnished': 'Unfurnished',
      'un-furnished': 'Unfurnished',
      'semi': 'Semi-Furnished',
      'semi-furnished': 'Semi-Furnished',
      'full': 'Fully Furnished',
      'fully': 'Fully Furnished',
      'fully-furnished': 'Fully Furnished'
    };
    const lowerType = furnishType.toLowerCase().trim();
    return furnishingMap[lowerType] || furnishType.replace(/-/g, ' ');
  };

  const getAmenityIcon = (amenityType) => {
    const amenityIconMap = {
      'Lift': ElevatorIcon,
      'Parking': LocalParkingIcon,
      'Gym': FitnessCenterIcon,
      'Swimming Pool': PoolIcon,
      'Pet Allowed': PetsIcon,
      'AC': AcUnitIcon,
      'TV': TvIcon,
      'Sofa': ChairIcon,
      'Fridge': KitchenIcon,
      'Furnished': WeekendIcon,
      'Internet': WifiIcon,
      'Washing Machine': LocalLaundryServiceIcon,
      'Microwave': MicrowaveIcon,
      'Power Backup': PowerIcon,
      'Security': SecurityIcon,
      'Sports': SportsBaseballIcon,
      'Children Area': ChildCareIcon,
      'Club House': HouseIcon,
      'Garden': ParkIcon,
      'Modular Kitchen': KitchenIcon,
      'BHK': BedIcon,
      'Floor': ApartmentIcon,
      'Size': SquareFootIcon,
      'Bathroom': BathtubIcon,
      'Facilities Distance': LocationOnIcon,
      'Carpet Area': AspectRatioIcon,
      'Built-up Area': AspectRatioIcon,
      'UDS': TerrainIcon,
      'Property Size': SquareFootIcon,
      'Length': StraightenIcon,
      'Width': StraightenIcon,
      'Zone Type': TerrainIcon,
      'Ownership': HouseIcon,
    };
    const IconComponent = amenityIconMap[amenityType] || SquareFootIcon;
    return <IconComponent sx={{ color: '#666', fontSize: 24 }} />;
  };

  const processMedia = (propertyData) => {
    const media = [];
    if (propertyData.images && Array.isArray(propertyData.images)) {
      propertyData.images.forEach((img, index) => {
        if (img.image) {
          const dataUrl = `data:image/jpeg;base64,${img.image}`;
          media.push({
            type: 'image',
            src: dataUrl,
            name: `property-image-${index + 1}`,
            thumbnail: dataUrl
          });
        }
        if (img.video_name) {
          media.push({
            type: 'video',
            src: `https://propertydealstalk.com/uploads/videos/${img.video_name}`,
            name: img.video_name,
            thumbnail: youtubeIcon
          });
        }
      });
    }
    return media;
  };

  const fetchAdminDetails = async (adminId) => {
    try {
      console.log('🔍 Fetching admin details for admin_id:', adminId);
      const response = await fetch(`https://propertydealstalk.com/api/admin/getAdmin?admin_id=${adminId}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch admin details');
      }

      const data = await response.json();
      console.log('📦 Admin API Response:', data);

      if (data.statusCode === 200 && data.result) {
        const adminData = Array.isArray(data.result) ? data.result[0] : data.result;
        setSellerDetails({
          full_name: adminData.full_name || 'Admin',
          contact_number: adminData.contact_number || adminData.phone || 'N/A',
          email_id: adminData.email_id || adminData.email || 'N/A',
          profile_image: adminData.profile_image || avatarIcon,
          role: 'admin'
        });
        console.log('✅ Admin details set successfully:', adminData);
      }
    } catch (err) {
      console.error('❌ Error fetching admin details:', err);
      setSellerDetails({
        full_name: 'Property Owner',
        contact_number: '+91 XXXXXXXXXX',
        email_id: 'contact@propertydealstalk.com',
        profile_image: avatarIcon,
        role: 'unknown'
      });
    }
  };

  const fetchSellerDetails = async (sellerId) => {
    try {
      console.log('🔍 Fetching seller details for seller_id:', sellerId);
      const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${sellerId}`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch seller details');
      }

      const data = await response.json();
      console.log('📦 Seller API Response:', data);

      if (data.status === "SUCCESS" && data.result) {
        setSellerDetails({
          full_name: data.result.full_name || 'Seller',
          contact_number: data.result.contact_number || 'N/A',
          email_id: data.result.email_id || 'N/A',
          profile_image: data.result.profile_image || avatarIcon,
          role: 'seller'
        });
        console.log('✅ Seller details updated successfully');
      }
    } catch (err) {
      console.error('❌ Error fetching seller details:', err);
    }
  };

  const checkFavoriteStatus = async (propId) => {
    if (!isLoggedIn || !user?.id || isSharedView) {
      setIsFavorite(false);
      return;
    }

    try {
      const response = await fetch(
        `https://propertydealstalk.com/api/buyer/getFavoritesByBuyerId?buyer_id=${user.id}`
      );
      const data = await response.json();

      if (data.statusCode === 200 && data.result) {
        const favorites = Array.isArray(data.result) ? data.result : [];
        const isInFavorites = favorites.some(
          fav => fav.property?.id === parseInt(propId) || fav.property_id === parseInt(propId)
        );
        setIsFavorite(isInFavorites);
        console.log('✅ Favorite status checked:', isInFavorites);
      } else {
        setIsFavorite(false);
      }
    } catch (err) {
      console.error('Error checking favorite status:', err);
      setIsFavorite(false);
    }
  };

  const toggleFavorite = async () => {
    if (!isLoggedIn) {
      navigate('/login');
      return;
    }

    try {
      if (isFavorite) {
        const response = await fetch('https://www.propertydealstalk.com/api/buyer/removeFavorite', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            buyer_id: user?.id,
            property_id: parseInt(property?.id || propertyId)
          })
        });

        const data = await response.json();

        if (data.statusCode === 200) {
          setIsFavorite(false);
          setToast({
            open: true,
            message: 'Property removed from favorites successfully',
            severity: 'success'
          });
          console.log('✅ Property removed from favorites');
        } else {
          throw new Error(data.message || 'Failed to remove property from favorites');
        }
      } else {
        const response = await fetch('https://propertydealstalk.com/api/buyer/addFavorites', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            buyer_id: user?.id,
            property_id: parseInt(property?.id || propertyId)
          })
        });

        const data = await response.json();

        if (data.statusCode === 200) {
          setIsFavorite(true);
          setToast({
            open: true,
            message: 'Property added to favorites successfully',
            severity: 'success'
          });
          console.log('✅ Property added to favorites');
        } else {
          throw new Error(data.message || 'Failed to add property to favorites');
        }
      }
    } catch (err) {
      console.error('Error toggling favorite:', err);
      setToast({
        open: true,
        message: err.message || 'Failed to update favorites',
        severity: 'error'
      });
    }
  };

  const handleShareClick = async () => {
    const publicUrl = `${window.location.origin}/view/${property?.id || propertyId}`;
    
    const shareData = {
      title: property?.property_name || 'Property on PropertyDealsTalk',
      text: `Check out ${property?.property_name || 'this property'} - ${
        property?.category === 'sale' || property?.commercial_catgory === 'sale'
          ? `${property?.currency || '₹'}${formatPrice(property?.asking_price)}`
          : `${property?.currency || '₹'}${formatPrice(property?.monthly_rent)}/month`
      } at ${property?.location || 'prime location'}`,
      url: publicUrl
    };

    if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
      try {
        await navigator.share(shareData);
        setToast({
          open: true,
          message: 'Shared successfully!',
          severity: 'success'
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          setShareUrl(publicUrl);
          setShareDialog(true);
        }
      }
    } else {
      setShareUrl(publicUrl);
      setShareDialog(true);
    }
  };

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setToast({
        open: true,
        message: 'URL copied to clipboard!',
        severity: 'success'
      });
    } catch (err) {
      console.error('Failed to copy URL:', err);
      setToast({
        open: true,
        message: 'Failed to copy URL',
        severity: 'error'
      });
    }
  };

  const handleCloseShareDialog = () => {
    setShareDialog(false);
  };

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setToast(prev => ({ ...prev, open: false }));
  };

  const fetchSimilarProperties = async (propId) => {
    if (!propId) return;

    setLoadingSimilar(true);
    try {
      const response = await fetch(`https://propertydealstalk.com/api/property/getSimilarProperties?property_id=${propId}`);

      if (!response.ok) {
        throw new Error('Failed to fetch similar properties');
      }

      const data = await response.json();

      if (data.statusCode === 200 && data.result && data.result.similar_properties) {
        setSimilarProperties(data.result.similar_properties.slice(0, 5));
      } else {
        console.warn('No similar properties found or invalid response format');
        setSimilarProperties([]);
      }
    } catch (err) {
      console.error('Error fetching similar properties:', err);
      setSimilarProperties([]);
    } finally {
      setLoadingSimilar(false);
    }
  };

  // ✅ ADDED: Socket initialization useEffect
  useEffect(() => {
    if (isLoggedIn && user?.id && !isSharedView && !socketInitializedRef.current) {
      console.log('🔌 Initializing socket connection for TalkView...');
      
      socketService.connect('https://propertydealstalk.com')
        .then(() => {
          console.log('✅ Socket connected in TalkView');
          
          // Register events
          socketEvents.registerEvents({
            onUserConnected: (data) => {
              console.log('✅ User Connected ACK received:', data);
            },
            onUserOnline: (data) => {
              console.log('👤 User Online broadcast:', data);
            },
            onConnectionStatus: (status) => {
              console.log('📡 Connection status:', status);
            },
            onError: (error) => {
              console.error('❌ Socket error:', error);
            }
          });
          
          socketInitializedRef.current = true;
        })
        .catch(error => {
          console.error('❌ Failed to connect socket:', error);
        });
    }

    return () => {
      if (socketInitializedRef.current) {
        console.log('🧹 Cleaning up socket in TalkView');
        socketInitializedRef.current = false;
      }
    };
  }, [isLoggedIn, user?.id, isSharedView]);

  useEffect(() => {
    setLoading(true);
    setError(null);
    setProperty(null);
    setPropertyMedia([]);
    setSelectedMediaIndex(0);
    setSellerDetails(null);

    const fetchPropertyDetails = async () => {
      try {
        const apiUrl = propertyId
          ? `https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}`
          : 'https://propertydealstalk.com/api/property/getProperties';

        console.log('🌐 Fetching property from:', apiUrl);
        const response = await fetch(apiUrl);

        if (!response.ok) {
          throw new Error('Failed to fetch property details');
        }

        const data = await response.json();
        console.log('📦 Property API Response:', data);

        if (data.statusCode === 200) {
          const propertyList = Array.isArray(data.result) ? data.result : [data.result];
          let selectedProperty;

          if (propertyId) {
            selectedProperty = Array.isArray(propertyList)
              ? propertyList.find(p => p && p.id === parseInt(propertyId))
              : propertyList;

            if (!selectedProperty && propertyList.length > 0) {
              selectedProperty = propertyList[0];
            }
          } else if (propertyList.length > 0) {
            selectedProperty = propertyList[0];
          }

          if (selectedProperty) {
            console.log('=== PROPERTY DETAILS ===');
            console.log('Property:', selectedProperty);
            console.log('Asset Type:', selectedProperty.asset_type);
            console.log('Carpet Area:', selectedProperty.carpet_area);
            console.log('Built-up Area:', selectedProperty.built_up_area);
            console.log('UDS:', selectedProperty.uds);
            console.log('Property Size:', selectedProperty.property_size);
            console.log('Length:', selectedProperty.length);
            console.log('Width:', selectedProperty.width);
            console.log('Zone Type:', selectedProperty.zone_type);
            
            setProperty(selectedProperty);
            const processedMedia = processMedia(selectedProperty);
            setPropertyMedia(processedMedia);

            setInquiryDialog(prev => ({
              ...prev,
              propertyId: selectedProperty.id,
              propertyTitle: selectedProperty.property_name
            }));

            if (selectedProperty.seller && selectedProperty.seller.full_name) {
              console.log('✅ Using seller data from API response');
              setSellerDetails(selectedProperty.seller);
            } else if (selectedProperty.added_by_admin && selectedProperty.admin_id) {
              console.log('🔄 Property added by admin, fetching admin details...');
              await fetchAdminDetails(selectedProperty.admin_id);
            } else if (selectedProperty.seller_id) {
              console.log('🔄 Fetching seller details for seller_id:', selectedProperty.seller_id);
              await fetchSellerDetails(selectedProperty.seller_id);
            } else {
              console.log('⚠️ No seller or admin information available');
              setSellerDetails({
                full_name: 'Property Owner',
                contact_number: '+91 XXXXXXXXXX',
                email_id: 'contact@propertydealstalk.com',
                profile_image: avatarIcon,
                role: 'unknown'
              });
            }

            fetchSimilarProperties(selectedProperty.id);

            if (isLoggedIn && user?.id && !isSharedView) {
              checkFavoriteStatus(selectedProperty.id);
            }
          } else {
            throw new Error('Property not found');
          }
        } else {
          throw new Error(data.message || 'Failed to fetch property details');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching property:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPropertyDetails();
  }, [propertyId, isLoggedIn, user?.id, isSharedView]);

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'profile_updated' && e.newValue === 'true') {
        console.log('Profile update detected in TalkView, refreshing seller details...');
        
        if (property?.seller_id) {
          fetchSellerDetails(property.seller_id);
        } else if (property?.added_by_admin && property?.admin_id) {
          fetchAdminDetails(property.admin_id);
        }
        
        localStorage.removeItem('profile_updated');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    const intervalId = setInterval(() => {
      if (localStorage.getItem('profile_updated') === 'true') {
        console.log('Profile update detected (same tab), refreshing seller details...');
        
        if (property?.seller_id) {
          fetchSellerDetails(property.seller_id);
        } else if (property?.added_by_admin && property?.admin_id) {
          fetchAdminDetails(property.admin_id);
        }
        
        localStorage.removeItem('profile_updated');
      }
    }, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(intervalId);
    };
  }, [property?.seller_id, property?.admin_id, property?.added_by_admin]);

  const handleSimilarPropertyClick = (propertyId) => {
    const sharedParam = isSharedView ? '?shared=true' : '';
    window.history.pushState({}, '', `/view/${propertyId}${sharedParam}`);

    setLoading(true);
    setError(null);
    setProperty(null);
    setPropertyMedia([]);
    setSelectedMediaIndex(0);
    setSimilarProperties([]);
    setSellerDetails(null);
    setIsFavorite(false);

    const fetchPropertyDetails = async () => {
      try {
        const apiUrl = `https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}`;
        const response = await fetch(apiUrl);

        if (!response.ok) {
          throw new Error('Failed to fetch property details');
        }

        const data = await response.json();

        if (data.statusCode === 200) {
          const propertyList = Array.isArray(data.result) ? data.result : [data.result];
          let selectedProperty;

          selectedProperty = Array.isArray(propertyList)
            ? propertyList.find(p => p && p.id === parseInt(propertyId))
            : propertyList;

          if (!selectedProperty && propertyList.length > 0) {
            selectedProperty = propertyList[0];
          }

          if (selectedProperty) {
            setProperty(selectedProperty);
            const processedMedia = processMedia(selectedProperty);
            setPropertyMedia(processedMedia);

            setInquiryDialog(prev => ({
              ...prev,
              propertyId: selectedProperty.id,
              propertyTitle: selectedProperty.property_name
            }));

            if (selectedProperty.seller && selectedProperty.seller.full_name) {
              setSellerDetails(selectedProperty.seller);
            } else if (selectedProperty.added_by_admin && selectedProperty.admin_id) {
              await fetchAdminDetails(selectedProperty.admin_id);
            } else if (selectedProperty.seller_id) {
              await fetchSellerDetails(selectedProperty.seller_id);
            }

            fetchSimilarProperties(selectedProperty.id);

            if (isLoggedIn && !isSharedView) {
              checkFavoriteStatus(selectedProperty.id);
            }
          } else {
            throw new Error('Property not found');
          }
        } else {
          throw new Error(data.message || 'Failed to fetch property details');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching property:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPropertyDetails();
    window.scrollTo(0, 0);
  };

  // ✅ UPDATED: handleOpenInquiry function
  const handleOpenInquiry = async () => {
    if (!isLoggedIn) {
      navigate('/login');
      return;
    }

    if (!user?.id) {
      console.error('❌ User ID not found');
      setToast({
        open: true,
        message: 'Please log in to contact the seller',
        severity: 'error'
      });
      return;
    }

    try {
      console.log('═══════════════════════════════════');
      console.log('🎯 CONTACT BUTTON CLICKED');
      console.log('👤 User ID:', user.id);
      console.log('═══════════════════════════════════');

      // Step 1: Check socket connection
      let isConnected = socketService.isSocketConnected();
      console.log('🔍 Socket connected?', isConnected);

      // Step 2: Connect if not connected
      if (!isConnected) {
        console.log('⚠️ Socket not connected, connecting...');
        await socketService.connect('https://propertydealstalk.com');
        
        // Register event listeners
        socketEvents.registerEvents({
          onUserConnected: (data) => {
            console.log('✅ User Connected ACK:', data);
          },
          onUserOnline: (data) => {
            console.log('👤 User Online broadcast:', data);
          },
          onConnectionStatus: (status) => {
            console.log('📡 Connection status:', status);
          },
          onError: (error) => {
            console.error('🔥 Socket error:', error);
          }
        });
        
        isConnected = socketService.isSocketConnected();
        console.log('✅ Socket connected:', isConnected);
      }

      // Step 3: Emit user_connected event
      console.log('📤 Emitting user_connected event...');
      console.log('   Payload: { user_id:', user.id, '}');
      
      socketEvents.userConnected(user.id);
      
      console.log('✅ user_connected event emitted successfully!');
      console.log('⏳ Waiting for connected_ack response...');

      // Step 4: Open inquiry dialog (CreateInquiry will handle create_inquiry)
      setInquiryDialog({
        open: true,
        propertyId: property?.id || propertyId,
        propertyTitle: property?.property_name || 'Property'
      });

      console.log('═══════════════════════════════════');

    } catch (error) {
      console.error('❌ Error in handleOpenInquiry:', error);
      setToast({
        open: true,
        message: 'Failed to connect. Please try again.',
        severity: 'error'
      });
    }
  };

  const handleCloseInquiry = () => {
    setInquiryDialog(prev => ({
      ...prev,
      open: false
    }));
  };

   const handleMediaSelect = (index) => {
    setSelectedMediaIndex(index);
  };

  const handleOpenModal = (index) => {
    setSelectedMediaIndex(index);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleModalNavigation = (direction) => {
    if (direction === 'next') {
      setSelectedMediaIndex((prev) => (prev + 1) % propertyMedia.length);
    } else {
      setSelectedMediaIndex((prev) => (prev - 1 + propertyMedia.length) % propertyMedia.length);
    }
  };

  const formatPrice = (price) => {
    return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || '';
  };

  const parseAmenities = (property) => {
    if (!property) return [];

    const amenitiesList = [];

    if (property.society_aminities) {
      const societyAmenities = property.society_aminities.split(',').map(item => item.trim());
      amenitiesList.push(...societyAmenities);
    }

    if (property.furnish_facilities) {
      const furnishFacilities = property.furnish_facilities.split(',').map(item => item.trim());
      amenitiesList.push(...furnishFacilities);
    }

    if (property.other_facilities) {
      const otherFacilities = property.other_facilities.split(',').map(item => item.trim());
      amenitiesList.push(...otherFacilities);
    }

    return [...new Set(amenitiesList)];
  };

  if (loading || !property) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  const allAmenities = parseAmenities(property);

  const assetTypeLower = (property.asset_type || '').toLowerCase().trim();
  const isApartment = assetTypeLower === 'apartment';
  const isIndependentHouse = assetTypeLower === 'independent house';
  const isPentHouse = assetTypeLower === 'pent house' || assetTypeLower === 'penthouse';
  const isStudio = assetTypeLower === 'studio';
  const isVilla = assetTypeLower === 'villa';
  const isPlot = assetTypeLower === 'plot';
  const isAgricultureLand = assetTypeLower === 'agriculture land';
  const isFarmhouse = assetTypeLower === 'farm house' || assetTypeLower === 'farmhouse';
  const isCommercial = property.property_type === 'commercial';
  const isOffice = assetTypeLower === 'office';
  const isShowroom = assetTypeLower === 'showroom';
  const isRetailShop = assetTypeLower === 'retail shop';
  const isWarehouse = assetTypeLower === 'warehouse' || assetTypeLower === 'ware house';

  console.log('🏠 Property Type Detection:', {
    assetTypeLower,
    isApartment,
    isIndependentHouse,
    isPentHouse,
    isStudio,
    isVilla,
    isPlot,
    isAgricultureLand,
    isFarmhouse,
    isCommercial,
    isOffice,
    isShowroom,
    isRetailShop,
    isWarehouse
  });

  const shouldShowAmenities = () => {
    return isFarmhouse || isVilla || (!isCommercial && !isPlot && !isAgricultureLand);
  };

  const getPropertyDetails = () => {
    const details = [];

    if (hasValue(property.bhk) && !isPlot && !isAgricultureLand && !isCommercial) {
      details.push({ type: 'BHK', value: `${property.bhk} BHK` });
    }

    if (hasValue(property.select_floor) && hasValue(property.total_floors) && !isPlot && !isAgricultureLand) {
      details.push({ type: 'Floor', value: `${property.select_floor}/${property.total_floors} Floor` });
    }

    if (isApartment && hasValue(property.carpet_area)) {
      const unit = hasValue(property.carpet_area_units) ? property.carpet_area_units : 'Sq.Ft';
      details.push({ type: 'Size', value: `${property.carpet_area} ${unit}` });
    } else if ((isIndependentHouse || isStudio || isVilla || isFarmhouse || isCommercial) && hasValue(property.property_size)) {
      const unit = hasValue(property.property_size_units) ? property.property_size_units : 'Sq.Ft';
      details.push({ type: 'Size', value: `${property.property_size} ${unit}` });
    } else if (isPentHouse && hasValue(property.built_up_area)) {
      const unit = hasValue(property.built_up_area_units) ? property.built_up_area_units : 'Sq.Ft';
      details.push({ type: 'Size', value: `${property.built_up_area} ${unit}` });
    } else if ((isPlot || isAgricultureLand) && hasValue(property.property_size)) {
      const unit = hasValue(property.property_size_units) ? property.property_size_units : 'Sq.Yards';
      details.push({ type: 'Size', value: `${property.property_size} ${unit}` });
    }

    return details;
  };

  const propertyDetails = getPropertyDetails();

  const getDisplayPrice = () => {
    const category = property.category || property.commercial_catgory || '';
    const isRental = category.toLowerCase() === 'rent';

    if (isRental) {
      if (hasValue(property.monthly_rent) && property.monthly_rent !== 0) {
        return property.monthly_rent;
      }
    }

    if (hasValue(property.asking_price) && property.asking_price !== 0) {
      return property.asking_price;
    }

    return null;
  };

  const displayPrice = getDisplayPrice();
  const isRentalProperty = (property.category || property.commercial_catgory || '').toLowerCase() === 'rent';

  const shouldShowContactInfo = isLoggedIn && !isSharedView;

  const sellerName = shouldShowContactInfo 
    ? (sellerDetails?.full_name || "Property Owner")
    : "Seller";
  
  const sellerContact = shouldShowContactInfo 
    ? (sellerDetails?.contact_number || "+91 XXXXXXXXXX")
    : '+91 123*****89';
  
  const sellerEmail = shouldShowContactInfo 
    ? (sellerDetails?.email_id || "seller@example.com")
    : 'Seller*****@gmail.com';
  
  const sellerImage = sellerDetails?.profile_image || avatarIcon;

  const propertyTitle = `${property.property_name || 'Property'} - PropertyDealsTalk`;
  const propertyDescription = `${
    property.category === 'sale' || property.commercial_catgory === 'sale' ? 'For Sale' : 'For Rent'
  }: ${property.property_name || 'Beautiful Property'} in ${
    property.location || 'Prime Location'
  }. Price: ${
    displayPrice && displayPrice !== 0 
      ? `${property.currency || '₹'}${formatPrice(displayPrice)}${isRentalProperty ? '/month' : ''}`
      : 'Price on Request'
  }. ${property.bhk ? `${property.bhk} BHK, ` : ''}${property.bedrooms || 0} Beds, ${property.bathrooms || 0} Baths.`;
  
  const logoUrl = `${window.location.origin}/HomeTitle.png`;
  const propertyUrl = window.location.href;

  const MainMediaDisplay = () => (
    <Box sx={{ position: 'relative', width: '100%', height: isMobile ? 250 : 450 }}>
      {propertyMedia.length > 0 ? (
        <>
          {propertyMedia[selectedMediaIndex].type === 'image' ? (
            <Box
              component="img"
              src={propertyMedia[selectedMediaIndex].src}
              alt={property.property_name}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: 2,
                cursor: 'pointer'
              }}
              onClick={() => handleOpenModal(selectedMediaIndex)}
            />
          ) : (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                bgcolor: '#000',
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                position: 'relative'
              }}
              onClick={() => handleOpenModal(selectedMediaIndex)}
            >
              <video
                src={propertyMedia[selectedMediaIndex].src}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 2
                }}
              />
              <PlayArrowIcon
                sx={{
                  position: 'absolute',
                  color: 'white',
                  fontSize: 60,
                  opacity: 0.8
                }}
              />
            </Box>
          )}
        </>
      ) : (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f5f5f5',
            borderRadius: 2,
            border: '1px dashed #ccc'
          }}
        >
          <Typography variant="h6" color="#888" textAlign="center">
            No images uploaded
          </Typography>
        </Box>
      )}

      {propertyMedia.length > 1 && (
        <Box
          sx={{
            position: 'absolute',
            top: 16,
            right: 16,
            bgcolor: 'rgba(0,0,0,0.7)',
            color: 'white',
            padding: '4px 12px',
            borderRadius: 2,
            fontSize: 14
          }}
        >
          {selectedMediaIndex + 1} / {propertyMedia.length}
        </Box>
      )}

      {propertyMedia.length > 1 && (
        <>
          <IconButton
            sx={{
              position: 'absolute',
              left: 16,
              top: '50%',
              transform: 'translateY(-50%)',
              bgcolor: 'rgba(255,255,255,0.9)',
              '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleMediaSelect((selectedMediaIndex - 1 + propertyMedia.length) % propertyMedia.length);
            }}
          >
            <Typography variant="h6" sx={{ color: '#000' }}>‹</Typography>
          </IconButton>
          <IconButton
            sx={{
              position: 'absolute',
              right: 16,
              top: '50%',
              transform: 'translateY(-50%)',
              bgcolor: 'rgba(255,255,255,0.9)',
              '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleMediaSelect((selectedMediaIndex + 1) % propertyMedia.length);
            }}
          >
            <Typography variant="h6" sx={{ color: '#000' }}>›</Typography>
          </IconButton>
        </>
      )}
    </Box>
  );

  const MediaThumbnails = () => (
    <>
      {propertyMedia.length > 1 && (
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            mt: 2,
            overflowX: 'auto',
            pb: 1,
            '&::-webkit-scrollbar': {
              height: 4,
            },
            '&::-webkit-scrollbar-track': {
              background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#888',
              borderRadius: 2,
            },
          }}
        >
          {propertyMedia.map((media, index) => (
            <Box
              key={index}
              sx={{
                position: 'relative',
                minWidth: 80,
                height: 80,
                borderRadius: 2,
                overflow: 'hidden',
                cursor: 'pointer',
                border: selectedMediaIndex === index ? '3px solid #2563EB' : '2px solid #ddd',
                opacity: selectedMediaIndex === index ? 1 : 0.7,
                transition: 'all 0.2s ease',
                '&:hover': {
                  opacity: 1,
                  transform: 'scale(1.05)'
                }
              }}
              onClick={() => handleMediaSelect(index)}
            >
              {media.type === 'image' ? (
                <Box
                  component="img"
                  src={media.src}
                  alt={`Thumbnail ${index + 1}`}
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    bgcolor: '#000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <PlayArrowIcon sx={{ color: 'white', fontSize: 24 }} />
                </Box>
              )}
              {media.type === 'video' && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 4,
                    right: 4,
                    bgcolor: 'rgba(0,0,0,0.7)',
                    borderRadius: '50%',
                    width: 20,
                    height: 20,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <PlayArrowIcon sx={{ color: 'white', fontSize: 12 }} />
                </Box>
              )}
            </Box>
          ))}
        </Box>
      )}
    </>
  );

  const PriceSection = () => (
    <Box
      bgcolor="#fff"
      p={3}
      borderRadius={2}
      mb={3}
      height={isMobile ? 'auto' : 'auto'}
      display="flex"
      flexDirection="column"
    >
      <Typography color="#2563EB" fontstyle="semibold" fontSize={22} fontWeight={600}>
        {displayPrice && displayPrice !== 0 ? (
          <>
            {property.currency || '₹'}{formatPrice(displayPrice)}
            {isRentalProperty && ' /month'}
          </>
        ) : (
          'Price on Request'
        )}
      </Typography>

      <Typography fontSize={17} my={1.5} fontWeight={600}>
        {property.property_name}
      </Typography>

      <Box display="flex" alignItems="center" gap={1} fontSize={14} fontWeight={400} color="#555" mb={1}>
        <LocationOnIcon sx={{ fontSize: 16, color: '#666' }} />
        {property.location}, {property.area_name}
      </Box>

      <Box display="flex" justifyContent="space-between" my={1} fontWeight={400} fontSize={13.5} color="#666">
        <Box display="flex" alignItems="center" gap={1}>
          <img src={calendarIcon} alt="Calendar" width={16} height={17} />
          {new Date(property.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
        </Box>
      </Box>

      {propertyDetails.length > 0 && (
        <Box display="flex" gap={isMobile ? 4 : 8} flexWrap="wrap" my={2} justifyContent="space-between">
          {propertyDetails.map((detail, index) => (
            <Box key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box sx={{ color: '#666', fontSize: 30, height: 40, display: 'flex', alignItems: 'center' }}>
                {getAmenityIcon(detail.type)}
              </Box>
              <Typography fontSize={14}>{detail.value}</Typography>
            </Box>
          ))}
        </Box>
      )}

      <hr style={{ margin: '8px 0', border: 'none', borderTop: '1px solid #eee' }} />

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="subtitle1" fontSize={17} fontWeight={600} color="#000000">
          Contact Seller
        </Typography>
        {shouldShowContactInfo && (
          <Button
            variant="text"
            sx={{ p: 0, minWidth: 'auto' }}
            onClick={handleOpenInquiry}
          >
            <img src={contactim} alt="Contact" style={{ height: 40 }} />
          </Button>
        )}
      </Box>

      <Box display="flex" alignItems="center" gap={3} mt={1}>
        <Avatar
          src={sellerImage}
          sx={{ width: 57, height: 62 }}
        />
        <Box>
          <Typography fontSize={15} fontWeight={500} color="#000000">
            {sellerName}
          </Typography>
          <Typography fontSize={13} color="blue" fontWeight={400}>
            {sellerContact}
          </Typography>
          <Typography fontSize={15} color="#000000" fontWeight={500}>
            {sellerEmail}
          </Typography>
        </Box>
      </Box>

      <hr style={{ margin: '12px 0', border: 'none', borderTop: '1px solid #eee' }} />

      {shouldShowContactInfo && (
        <Box display="flex" gap={3} mt={2} alignItems="center">
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={{ cursor: 'pointer' }}
            onClick={toggleFavorite}
          >
            {isFavorite ? (
              <FavoriteIcon sx={{ color: 'red', fontSize: 32 }} />
            ) : (
              <FavoriteBorderIcon sx={{ color: '#666', fontSize: 32 }} />
            )}
            <Typography fontSize={14} fontWeight={500} color="#000">
              {isFavorite ? 'Saved' : 'Save'}
            </Typography>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={{ cursor: 'pointer' }}
            onClick={handleShareClick}
          >
            <ShareIcon sx={{ color: '#666', fontSize: 28 }} />
            <Typography fontSize={14} fontWeight={500} color="#000">
              Share
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );

  const DescriptionBox = () => (
    <Box mt={isMobile ? 0 : 4} bgcolor="#fff" p={3} borderRadius={2}>
      {hasValue(property.description) && (
        <>
          <Typography variant="h6" mb={2}>Property Description</Typography>
          <Typography fontSize={14} color="#626262" mb={2}>
            {property.description}
          </Typography>
        </>
      )}

      {hasValue(property.content) && (
        <>
          <Typography variant="h6" mb={2} mt={hasValue(property.description) ? 3 : 0}>
            Additional Content
          </Typography>
          <Typography fontSize={14} color="#626262" mb={2}>
            {property.content}
          </Typography>
        </>
      )}

      {hasValue(property.full_address) && (
        <>
          <Typography variant="h6" mb={2} mt={3}>Complete Address</Typography>
          <Typography fontSize={14} color="#626262" mb={2}>
            {property.full_address}
          </Typography>
        </>
      )}

      {(isApartment || isIndependentHouse || isPentHouse || isStudio || isVilla || isFarmhouse || isCommercial) && (
        <>
          <Typography variant="subtitle1" mt={3} mb={2} fontWeight={500}>
            Area Details
          </Typography>
          
          {isApartment && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {hasValue(property.carpet_area) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Carpet Area')}
                    <span>Carpet Area</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.carpet_area} {property.carpet_area_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
              {hasValue(property.built_up_area) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Built-up Area')}
                    <span>Built-up Area</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
              {hasValue(property.uds) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('UDS')}
                    <span>UDS</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.uds} {property.uds_units || 'Sq.Yards'}
                  </Box>
                </Box>
              )}
            </Box>
          )}

          {isIndependentHouse && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {hasValue(property.built_up_area) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Built-up Area')}
                    <span>Built-up Area</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
              {hasValue(property.property_size) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Property Size')}
                    <span>Property Size</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.property_size} {property.property_size_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
              {hasValue(property.uds) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('UDS')}
                    <span>UDS</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.uds} {property.uds_units || 'Sq.Yards'}
                  </Box>
                </Box>
              )}
            </Box>
          )}

          {isPentHouse && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {hasValue(property.built_up_area) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Built-up Area')}
                    <span>Built-up Area</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
              {hasValue(property.carpet_area) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Carpet Area')}
                    <span>Carpet Area</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.carpet_area} {property.carpet_area_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
              {hasValue(property.uds) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('UDS')}
                    <span>UDS</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.uds} {property.uds_units || 'Sq.Yards'}
                  </Box>
                </Box>
              )}
            </Box>
          )}

          {isStudio && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {hasValue(property.property_size) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Property Size')}
                    <span>Property Size</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.property_size} {property.property_size_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
              {hasValue(property.carpet_area) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Carpet Area')}
                    <span>Carpet Area</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.carpet_area} {property.carpet_area_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
              {hasValue(property.uds) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('UDS')}
                    <span>UDS</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.uds} {property.uds_units || 'Sq.Yards'}
                  </Box>
                </Box>
              )}
            </Box>
          )}
          
          {isVilla && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {hasValue(property.built_up_area) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Built-up Area')}
                    <span>Built-up Area</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
              {hasValue(property.property_size) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Property Size')}
                    <span>Property Size</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.property_size} {property.property_size_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
            </Box>
          )}

          {isFarmhouse && !isCommercial && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {hasValue(property.built_up_area) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Built-up Area')}
                    <span>Built-up Area</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
                           {hasValue(property.property_size) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Property Size')}
                    <span>Property Size</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.property_size} {property.property_size_units || 'Acres'}
                  </Box>
                </Box>
              )}
            </Box>
          )}

          {isCommercial && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {hasValue(property.built_up_area) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Built-up Area')}
                    <span>Built-up Area</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
              {hasValue(property.property_size) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Property Size')}
                    <span>Property Size</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.property_size} {property.property_size_units || (isFarmhouse ? 'Acres' : 'Sq.Ft')}
                  </Box>
                </Box>
              )}
              {hasValue(property.carpet_area) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Carpet Area')}
                    <span>Carpet Area</span>
                  </Box>
                  <Box fontWeight="bold">
                    {property.carpet_area} {property.carpet_area_units || 'Sq.Ft'}
                  </Box>
                </Box>
              )}
              {hasValue(property.zone_type) && (
                <Box display="flex" gap={3} fontSize={14} color="#626262">
                  <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                    {getAmenityIcon('Zone Type')}
                    <span>Zone Type</span>
                  </Box>
                  <Box fontWeight="bold">{property.zone_type}</Box>
                </Box>
              )}
            </Box>
          )}
        </>
      )}

      {(isPlot || isAgricultureLand) && (
        <>
          <Typography variant="subtitle1" mt={3} mb={2} fontWeight={500}>
            Plot Details
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {hasValue(property.property_size) && (
              <Box display="flex" gap={3} fontSize={14} color="#626262">
                <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                  {getAmenityIcon('Property Size')}
                  <span>Property Size</span>
                </Box>
                <Box fontWeight="bold">
                  {property.property_size} {property.property_size_units || 'Sq.Yards'}
                </Box>
              </Box>
            )}
            {hasValue(property.zone_type) && (
              <Box display="flex" gap={3} fontSize={14} color="#626262">
                <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                  {getAmenityIcon('Zone Type')}
                  <span>Zone Type</span>
                </Box>
                <Box fontWeight="bold">{property.zone_type}</Box>
              </Box>
            )}
              
              {/* ✅ ADD OWNERSHIP HERE for Plot/Agriculture Land */}
{hasValue(property.ownership) && (
  <Box display="flex" gap={3} fontSize={14} color="#626262">
    <Box minWidth={150} display="flex" alignItems="center" gap={1}>
     {getAmenityIcon('Ownership')} {/* ✅ Changed from 'Zone Type' */}
      <span>Ownership</span>
    </Box>
    <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
      {property.ownership}
    </Box>
  </Box>
)}


            {!isAgricultureLand && hasValue(property.length) && (
              <Box display="flex" gap={3} fontSize={14} color="#626262">
                <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                  {getAmenityIcon('Length')}
                  <span>Length</span>
                </Box>
                <Box fontWeight="bold">
                  {property.length} {property.length_units || 'Feet'}
                </Box>
              </Box>
            )}
            {!isAgricultureLand && hasValue(property.width) && (
              <Box display="flex" gap={3} fontSize={14} color="#626262">
                <Box minWidth={150} display="flex" alignItems="center" gap={1}>
                  {getAmenityIcon('Width')}
                  <span>Width</span>
                </Box>
                <Box fontWeight="bold">
                  {property.width} {property.width_units || 'Feet'}
                </Box>
              </Box>
            )}
          </Box>
        </>
      )}

      {shouldShowAmenities() && allAmenities.length > 0 && (
        <>
          <Typography variant="subtitle1" mb={2} mt={3} fontWeight={500}>
            Features & Amenities
          </Typography>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
              columnGap: 4,
              rowGap: 2,
            }}
          >
            {allAmenities.map((amenity, index) => (
              <Box key={index} display="flex" alignItems="center" gap={1} fontSize={14} fontWeight="bold">
                {getAmenityIcon(amenity)}
                {amenity}
              </Box>
            ))}
          </Box>
        </>
      )}

      <Typography variant="subtitle1" mt={3} fontWeight={500}>Additional Details</Typography>
      <Box mt={1}>
        <Box
          display="flex"
          flexWrap="wrap"
          alignItems="center"
          gap={isMobile ? 1 : 3}
          mb={1}
          fontSize={14}
          color="#626262"
          fontWeight={400}
        >
          <Box minWidth={130}>Property Type</Box>
          <Box fontWeight="bold">{property.property_type} {property.asset_type}</Box>
        </Box>

        <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
          <Box minWidth={130}>Property ID</Box>
          <Box fontWeight="bold">#{property.id}</Box>
        </Box>

        {hasValue(property.negotiable) && (
          <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
            <Box minWidth={130}>Price Negotiable</Box>
            <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
              {property.negotiable === 'true' || property.negotiable === true ? 'Yes' : 'No'}
            </Box>
          </Box>
        )}

        {hasValue(property.total_floors) && !isPlot && !isAgricultureLand && (
          <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
            <Box minWidth={130}>Total Floors</Box>
            <Box fontWeight="bold">{property.total_floors}</Box>
          </Box>
        )}

        {hasValue(property.select_floor) && !isPlot && !isAgricultureLand && (
          <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
            <Box minWidth={130}>Floor Number</Box>
            <Box fontWeight="bold">{property.select_floor}</Box>
          </Box>
        )}

        {hasValue(property.furnish_type) && !isPlot && !isAgricultureLand && !isCommercial && (
          <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
            <Box minWidth={130}>Furnishing</Box>
            <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
              {getFurnishingTypeName(property.furnish_type)}
            </Box>
          </Box>
        )}

        {hasValue(property.construction_status) && (
          <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
            <Box minWidth={130}>Construction Status</Box>
            <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
              {property.construction_status}
            </Box>
          </Box>
        )}

        {hasValue(property.monthly_rent) && (
          <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
            <Box minWidth={130}>Monthly Rent</Box>
            <Box fontWeight="bold">
              {property.currency || '₹'}{formatPrice(property.monthly_rent)}
            </Box>
          </Box>
        )}

        {hasValue(property.security_deposit) && (
          <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
            <Box minWidth={130}>Security Deposit</Box>
            <Box fontWeight="bold">{property.security_deposit}</Box>
          </Box>
        )}

        {hasValue(property.available_from) && (
          <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
            <Box minWidth={130}>Available From</Box>
            <Box fontWeight="bold">
              {new Date(property.available_from).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              })}
            </Box>
          </Box>
        )}

        {/* ✅ MODIFIED: Only show ownership for COMMERCIAL properties, not Plot/Agriculture */}
{hasValue(property.ownership) && isCommercial && !isPlot && !isAgricultureLand && (
  <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
    <Box minWidth={130}>Ownership</Box>
    <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
      {property.ownership}
    </Box>
  </Box>
)}


        {hasValue(property.hub) && isCommercial && (
          <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
            <Box minWidth={130}>Hub</Box>
            <Box fontWeight="bold">{property.hub}</Box>
          </Box>
        )}

        {hasValue(property.commercial_catgory) && isCommercial && (
          <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
            <Box minWidth={130}>Category</Box>
            <Box fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
              {property.commercial_catgory}
            </Box>
          </Box>
        )}

        {hasValue(property.youtube_link) && property.youtube_link !== "null" && (
          <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
            <Box minWidth={130}>Social media Link</Box>
            <Box fontWeight="bold" sx={{ wordBreak: 'break-all' }}>
              {shouldShowContactInfo ? (
                <a
                  href={property.youtube_link.trim()}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#2563EB',
                    textDecoration: 'underline',
                    cursor: 'pointer'
                  }}
                >
                  {property.youtube_link.trim()}
                </a>
              ) : (
                <span style={{ color: '#2563EB' }}>https://youtu.be/****</span>
              )}
            </Box>
          </Box>
        )}

        {propertyMedia.some(media => media.type === 'video') && (
          <Box display="flex" gap={3} mb={1} fontSize={14} color="#626262">
            <Box minWidth={130}>Property Video</Box>
            <Box fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <img src={youtubeIcon} alt="Video" width={18} />
              Available
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );

  const SimilarPropertiesSection = () => (
    <Box bgcolor="#fff" p={3} borderRadius={2} mt={isMobile ? 3 : 0}>
      <Typography variant="subtitle1" mb={2} fontWeight={600}>
        Similar Properties
      </Typography>
      {loadingSimilar ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress size={24} />
        </Box>
      ) : similarProperties.length === 0 ? (
        <Typography color="#666">No similar properties found.</Typography>
      ) : (
        similarProperties.map((sim) => {
          const simImageSrc = sim.image
            ? `data:image/png;base64,${sim.image}`
            : similarImg;

          return (
            <Box
              key={sim.id}
              display="flex"
              alignItems="center"
              gap={2}
              mb={2}
              sx={{
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: '#f5f8ff',
                  borderRadius: '8px'
                },
                p: 1
              }}
              onClick={() => handleSimilarPropertyClick(sim.id)}
            >
              <img
                src={simImageSrc}
                alt={sim.property_name || 'Similar Property'}
                width={60}
                height={60}
                style={{ borderRadius: 8, objectFit: 'cover' }}
              />
              <Box>
                <Typography fontSize={13} fontWeight={500}>
                  {sim.property_name || `${sim.asset_type || ''} ${sim.property_type || ''}`}
                </Typography>
                <Typography fontSize={13} color="#2563EB" fontWeight={500}>
                  {sim.currency || '₹'}
                  {formatPrice(sim.asking_price)}
                </Typography>
                <Typography fontSize={12} color="#666">
                  {sim.area_name ? `${sim.area_name}, ${sim.location}` : `${sim.location}`}
                </Typography>
              </Box>
            </Box>
          );
        })
      )}
    </Box>
  );

  return (
    <>
      <Helmet>
        <title>{propertyTitle}</title>
        <meta name="title" content={propertyTitle} />
        <meta name="description" content={propertyDescription} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={propertyUrl} />
        <meta property="og:title" content={propertyTitle} />
        <meta property="og:description" content={propertyDescription} />
        <meta property="og:image" content={logoUrl} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="PropertyDealsTalk" />

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={propertyUrl} />
        <meta property="twitter:title" content={propertyTitle} />
        <meta property="twitter:description" content={propertyDescription} />
        <meta property="twitter:image" content={logoUrl} />

        <meta property="og:image:alt" content={property.property_name || 'Property on PropertyDealsTalk'} />
      </Helmet>

      <Box
        sx={{
          background: '#f9f9f9',
          fontFamily: 'Outfit, sans-serif',
          px: isMobile ? 2 : 6,
          py: isMobile ? 2 : 4,
        }}
      >
        {isMobile ? (
          <Box>
            <MainMediaDisplay />
            <MediaThumbnails />
            <Box mt={3}>
              <PriceSection />
            </Box>
            <Box mt={3}>
              <DescriptionBox />
            </Box>
            <SimilarPropertiesSection />
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 4,
            }}
          >
            <Box sx={{ flex: 1 }}>
              <MainMediaDisplay />
              <MediaThumbnails />
              <DescriptionBox />
            </Box>

            <Box sx={{ flex: 1, maxWidth: 420 }}>
              <PriceSection />
              <SimilarPropertiesSection />
            </Box>
          </Box>
        )}

        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(5px)'
          }}
        >
          <Box sx={{ position: 'relative', maxWidth: '90vw', maxHeight: '90vh' }}>
            <IconButton
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                bgcolor: 'rgba(0,0,0,0.5)',
                color: 'white',
                zIndex: 1000,
                '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
              }}
              onClick={handleCloseModal}
            >
              <CloseIcon />
            </IconButton>

            {propertyMedia.length > 1 && (
              <>
                <IconButton
                  sx={{
                    position: 'absolute',
                    left: 8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    zIndex: 1000,
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                  }}
                  onClick={() => handleModalNavigation('prev')}
                >
                  <Typography variant="h6">‹</Typography>
                </IconButton>
                <IconButton
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(0,0,0,0.5)',
                    color: 'white',
                    zIndex: 1000,
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' }
                  }}
                  onClick={() => handleModalNavigation('next')}
                >
                  <Typography variant="h6">›</Typography>
                </IconButton>
              </>
            )}

            {propertyMedia[selectedMediaIndex]?.type === 'image' ? (
              <Box
                component="img"
                src={propertyMedia[selectedMediaIndex].src}
                alt={property.property_name}
                sx={{
                  maxWidth: '100%',
                  maxHeight: '90vh',
                  objectFit: 'contain'
                }}
              />
            ) : (
              <Box
                sx={{
                  width: '80vw',
                  height: '80vh',
                  bgcolor: '#000'
                }}
              >
                <video
                  src={propertyMedia[selectedMediaIndex]?.src}
                  controls
                  autoPlay
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                  }}
                />
              </Box>
            )}
          </Box>
        </Modal>

        <Dialog
          open={shareDialog}
          onClose={handleCloseShareDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" fontWeight={600}>Share Property</Typography>
            <IconButton onClick={handleCloseShareDialog} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body2" color="#666" mb={2}>
              Share this property link with others. Anyone with this link can view the property details.
            </Typography>
            <TextField
              fullWidth
              value={shareUrl}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleCopyUrl}
                      edge="end"
                      color="primary"
                      title="Copy URL"
                    >
                      <ContentCopyIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#f5f5f5',
                }
              }}
            />
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={handleCloseShareDialog} variant="outlined">
              Close
            </Button>
            <Button onClick={handleCopyUrl} variant="contained" startIcon={<ContentCopyIcon />}>
              Copy Link
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={toast.open}
          autoHideDuration={6000}
          onClose={handleCloseToast}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%' }}>
            {toast.message}
          </Alert>
        </Snackbar>

        <CreateInquiry
          open={inquiryDialog.open}
          onClose={handleCloseInquiry}
          propertyId={inquiryDialog.propertyId}
          buyerId={user?.id || 1}
          propertyTitle={inquiryDialog.propertyTitle}
        />
      </Box>
    </>
  );
};

export default TalkView;


